import { Heading } from '@boltenergy-be/design-system'

const TermsDutch = () => {
  return (
    <>
      <Heading as="h2" variant="h3">
        Algemene Voorwaarden voor de levering van elektriciteit en/of aardgas door Bolt Energie B.V. (hierna “wij”) aan de klant (hierna
        “u”) en de teruglevering van elektriciteit _ 14/02/2025
      </Heading>

      <h3>1. De definities en toepassing Algemene Voorwaarden (hierna “AV”)</h3>

      <p>Actief product: een Leveringsovereenkomst of Teurgleveringsovereenkomst waarop u zich online kan intekenen.</p>

      <p>
        Bijzondere Voorwaarden: ons document waarin de prijs, de Teruglevergoeding, de Energiedienst de duur en de bijzondere bepalingen van
        de Leveringsovereenkomst en/of de Terugleveringsovereenkomst worden vermeld (hierna “BV”).
      </p>

      <p>Energiedienst: het faciliteren van energiebesparing voor de klant op basis van algemene en gepersonaliseerde adviezen</p>

      <p>Goedkoopste equivalent product: de goedkoopste standaardovereenkomst in ons aanbod.</p>

      <p>
        Huishoudelijke afnemer: een natuurlijke persoon die elektriciteit en/of aardgas aankoopt voor zijn eigen huishoudelijk gebruik met
        uitsluiting van commerciële of professionele activiteiten.
      </p>

      <p>
        Kleine Professionele Verbruiker: iedere natuurlijke persoon of rechtspersoon die elektriciteit en/of aardgas aankoopt gedeeltelijk
        of uitsluitend voor professionele doeleinden, en waarvan het jaarlijks verbruik voor al zijn Leverpunten samen minder dan 50 MWh
        elektriciteit en minder dan 100 MWh aardgas bedraagt voor contracten die vóór 1 september 2021 worden gesloten, gewijzigd of
        hernieuwd en minder dan 100 MWh elektriciteit en/of minder dan 100 MWh aardgas voor contracten die vanaf 1 september 2021 worden
        gesloten, gewijzigd of hernieuwd.
      </p>

      <p>Levering: het voorzien op het Leverpunt van elektriciteit en/of aardgas.</p>

      <p>
        Leveringsovereenkomst: het geheel van de overeenkomst tussen u en ons betreffende de Levering; de AV, de BV, de bijlages die
        betrekking hebben op de levering in het Brussels Hoofdstedelijk en het Waalse Gewest, evenals elke schriftelijke aanvulling of
        aanpassing daarvan maken deel uit van deze Leveringsovereenkomst; in geval van tegenstrijdigheden hebben de BV voorrang.
      </p>

      <p>
        Leverpunt: het overeengekomen punt waar wij elektriciteit en/of aardgas leveren en eventueel Energiediensten leveren, en waar u
        desgevallend ook elektriciteit terug levert aan Bolt; dit punt heeft een uniek EAN-nummer.
      </p>

      <p>
        Netbeheerder: de beheerder van het nationaal, regionaal of lokaal net voor de transmissie, het vervoer of de distributie van
        elektriciteit en/of aardgas.
      </p>

      <p>
        Nettarieven: de tarieven voor het gebruik van het distributie-, lokaal transport- en/of transmissienet voor elektriciteit en
        aardgas.
      </p>

      <p>Producent Elektriciteit: de door Bolt aangeboden en door u gekozen producent van lokale en groene elektriciteit.</p>

      <p>Teruglevering: de verkoop van door de klant geproduceerde en op het Leverpunt geïnjecteerde elektriciteit aan Bolt.</p>

      <p>
        Terugleveringsovereenkomst: het geheel van de overeenkomst tussen u en ons betreffende de Teruglevering; de AV, de BV evenals elke
        schriftelijke aanvulling of aanpassing daarvan maken deel uit van deze Terugleveringsovereenkomst; in geval van tegenstrijdigheden
        hebben de BV voorrang.
      </p>

      <p>
        Terugleveringsvergoeding: de vergoeding die Bolt aan de klant betaalt voor de door hem geproduceerde en op het Leverpunt
        geïnjecteerde elektriciteit.
      </p>

      <p>Vaste vergoeding: forfaitaire vergoeding voor administratieve kosten of abonnementskosten die wij aan u aanrekenen.</p>

      <p>
        De begrippen die niet in deze Leveringsovereenkomst en/of Terugleveringsovereenkomst zijn gedefinieerd, hebben de betekenis zoals
        vastgelegd in de toepasselijke regelgeving (inclusief de technische reglementen). Voor meer uitleg over de regionale regelgevingen
        verwijzen wij naar de websites van de bevoegde regulatoren.
      </p>

      <p>
        Deze AV zijn van toepassing op de levering van elektriciteit en aardgas aan Huishoudelijke afnemers en aan Kleine Professionele
        Verbruikers. Door de Leveringsovereenkomst te ondertekenen, stemt u in met deze AV.
      </p>

      <h3>2. Leveringsovereenkomst</h3>

      <p>
        2.1. Wij zullen elektriciteit en/of aardgas en/of Energiediensten leveren zoals in de Leveringsovereenkomst bepaald. U zal op het
        Leverpunt onze elektriciteit en/of aardgas afnemen, ons de overeengekomen prijs betalen en de andere bepalingen van de
        Leveringsovereenkomst naleven. De Leveringsovereenkomst doet geen afbreuk aan de wettelijke bepalingen, o.m. inzake openbare
        dienstverplichtingen.
      </p>

      <p>
        2.2. Indien wij ten gevolge van wijzigingen in het regelgevend kader of door andere buiten onze invloed liggende omstandigheden niet
        voldoende uit hernieuwbare bronnen opgewekte duurzame energie beschikbaar hebben, kunnen we de levering aanvullen met andersoortige,
        maar wel zoveel mogelijk duurzaam opgewekte energie.
      </p>

      <h3>3. Terugleveringsovereenkomst</h3>

      <p>
        3.1. U kan enkel een Terugleveringsovereenkomst sluiten met Bolt als u ook een Leveringsovereenkomst met Bolt heeft afgesloten en u
        beschikt over een digitale meter op het Leverpunt. Een digitale meter meet uw afname en injectie van elektriciteit afzonderlijk en
        kan vanop afstand worden uitgelezen.
      </p>

      <p>
        3.2. Als wij een Terugleveringsovereenkomst sluiten, betaalt Bolt u een vergoeding voor de elektriciteit die u zelf produceert en
        injecteert op het Leverpunt. Deze vergoeding wordt bepaald in de BV.
      </p>

      <h3>4. Totstandkoming van de Leveringsovereenkomst en/of Terugleveringsovereenkomst</h3>

      <p>
        4.1. Indien de Leveringsovereenkomst en/of de Terugleveringsovereenkomst met u op afstand wordt gesloten (bv. via onze website of de
        telefoon) of buiten de verkoopruimten van onze onderneming (bv. op evenementen, via deur-aan-deur verkoop) en u een Huishoudelijke
        afnemer bent, zal de Leveringsovereenkomst en/of Terugleveringsovereenkomst u schriftelijk (per brief of per e-mail) worden
        bevestigd.
      </p>

      <p>
        4.2. De Overeenkomst komt tot stand onder opschortende voorwaarden van onze aanvaarding en de bevestiging door de netbeheerder van
        uw gegevens. Onze aanvaarding baseren we, in de mate dat de regelgeving dit toelaat, onder andere op het gegeven
      </p>

      <ul>
        <li>of aan de technische voorwaarden om u te beleveren is voldaan;</li>

        <li>
          of de contractuele voorwaarden en de tariefkaart die u hebt aanvaard, van toepassing zijn en gelden op het ogenblik dat wij uw
          Contract ontvangen;
        </li>

        <li>of u eerdere uitstaande schulden hebt bij ons;</li>

        <li>of u voldoende kredietwaardig bent;</li>

        <li>of u een bijzonder risico inhoudt voor ons.</li>
      </ul>

      <p>Dit geldt eveneens wanneer u intekent op een aanbod van een groepsaankoop.</p>

      <p>Uw kredietwaardigheid kunnen we baseren op gezuiverde schulden, openstaande schulden en toekomstige risico’s.</p>

      <p>
        In geval van twijfel over uw kredietwaardigheid kunnen we als opschortende voorwaarde van onze aanvaarding eisen dat u een waarborg
        betaalt of dat u een door ons aanvaardde derde aanstelt als borg ten aanzien van ons. Het exacte bedrag, de modaliteiten m.b.t. de
        berekening, betaling en vrijgave, worden in het verzoek toegelicht.
      </p>

      <p>
        Wij kunnen tijdens de duur van de overeenkomst steeds een waarborg eisen van u in overeenstemming met de huidige regelgeving. Een
        waarborg door ons geëist tijdens de duur van de overeenkomst is steeds gelijk aan het geschatte verbruik van één of meerdere maanden
        en moet binnen de 15 kalenderdagen na ons verzoek zijn gesteld. Het exacte bedrag, de modaliteiten m.b.t. de berekening, betaling en
        vrijgave, worden in het verzoek toegelicht.
      </p>

      <p>
        4.3. De Levering en/of Teruglevering start zodra wij door de Netbeheerder als leverancier voor het Leverpunt en/of, in geval van
        Teruglevering, als koper van de door de klant op het Leverpunt geïnjecteerde elektriciteit in het aansluitingsregister of
        toegangsregister werden geregistreerd. Indien u een Huishoudelijke afnemer bent en de Leveringsovereenkomst en/of de
        Terugleveringsovereenkomst op afstand of buiten de verkoopruimten van onze onderneming of onze partners werd gesloten, start de
        Levering en/of Teruglevering ten vroegste na afloop van de herroepingstermijn, tenzij u ons uitdrukkelijk verzoekt om de levering
        van elektriciteit en/of aardgas reeds te laten beginnen tijdens de herroepingstermijn voorzien in artikel 5.1.
      </p>

      <p>
        4.4. Huishoudelijke afnemers die bij het afsluiten van de Leveringsovereenkomst en/of Terugleveringsovereenkomst nog gebonden zijn
        door een leveringsovereenkomst en/of terugleveringsovereenkomst met een andere leverancier met betrekking tot het Leverpunt, geven
        ons een uitdrukkelijk mandaat om voor hen deze leveringsovereenkomst en/of terugleveringsovereenkomst te beëindigen. Klanten die nog
        gebonden zijn door een terugleveringsovereenkomst met een andere partij dan een leverancier (zoals een aggregator), doen zelf het
        nodige om deze te beëindigen en het bewijs hiervan aan Bolt te bezorgen.
      </p>

      <h3>5. Herroepingsrecht</h3>

      <p>
        5.1. Als u een Huishoudelijke afnemer bent, heeft u het recht om af te zien van deze Leveringsovereenkomst en/of
        Terugleveringsovereenkomst, zonder betaling van een boete en zonder opgave van motief, en dit binnen een herroepingstermijn die
        verstrijkt 14 kalenderdagen vanaf de ontvangst van de bevestiging van de Leveringsovereenkomst en/of Terugleveringsovereenkomst
        vanwege Bolt, of indien de Leveringsovereenkomst en/of Terugleveringsovereenkomst per telefoon wordt gesloten, vanaf de datum van
        bevestiging van de Leveringsovereenkomst en/of Terugleveringsovereenkomst door u. Om dit herroepingsrecht uit te oefenen, moet u
        Bolt via een ondubbelzinnige schriftelijke verklaring (bijvoorbeeld per post, fax of e-mail) op de hoogte stellen van deze
        beslissing. U kunt hiervoor gebruik maken van het modelformulier voor herroeping dat aangehecht is aan deze AV.
      </p>

      <p>
        5.2. Als u uitdrukkelijk heeft verzocht om de levering van elektriciteit en/of aardgas te laten beginnen tijdens de
        herroepingstermijn, betaalt u een bedrag dat evenredig is aan wat reeds geleverd is op het moment dat u ons in kennis stelt dat u de
        Leveringsovereenkomst herroept. Als u ervoor heeft gekozen om ook uw Terugleveringsovereenkomst te laten beginnen tijdens de
        herroepingstermijn, betaalt Bolt u een Terugleveringvergoeding voor de elektriciteit die u heeft geïnjecteerd op het Leverpunt vanaf
        de startdatum van de Terugleveringsovereenkomst tot op het moment dat u ons in kennis stelt dat u de Terugleveringsovereenkomst
        herroept.
      </p>

      <h3>6. Duur</h3>

      <p>
        6.1. De Leveringsovereenkomst en/of Terugleveringsovereenkomst wordt afgesloten voor bepaalde of onbepaalde duur. Of uw
        Leveringsovereenkomst en/of Terugleveringsovereenkomst van bepaalde of onbepaalde duur is, wordt vermeld in de BV.
      </p>

      <p>
        6.2. We verlengen de Leveringsovereenkomst en/of Terugleveringsovereenkomst van bepaalde duur uitsluitend wanneer het product nog
        actief is en de prijs ongewijzigd is, en dit voor de duur zoals bepaald in de BV. Wij zijn niet verplicht om uw Overeenkomst te
        verlengen. Als de prijs wijzigde of het product niet langer actief is, sturen wij u twee maanden voor het einde van de lopende
        Leveringsovereenkomst en/of Terugleveringsovereenkomst een overzicht van ons aanbod en doen wij u een nieuw aanbod. Als u niet
        akkoord gaat met dat aanbod en u de overeenkomst niet opzegt, passen wij het goedkoopste equivalent product op u toe. U kan ook zelf
        afzien van de verlenging of vernieuwing door ons dit ten minste drie weken vóór de einddatum van de lopende overeenkomst
        schriftelijk (per brief of per e-mail) mee te delen. .
      </p>

      <p>
        6.3. U kan uw Leveringsovereenkomst van bepaalde of onbepaalde duur op ieder moment schriftelijk (per brief of per e-mail) opzeggen,
        mits naleving van een opzegtermijn van ten minste drie weken. De afsluiting van het Leverpunt of de kennisgeving van de wijziging
        van leverancier via de Netbeheerder wordt, voor dit Leverpunt, beschouwd als een opzegging van de Leveringsovereenkomst en/of de
        Terugleveringsovereenkomst door u.
      </p>

      <p>
        Als u Uw Leveringsovereenkomst aan een variabele energieprijs en met een vaste vergoeding beëindigt minder dan zes maanden na de
        aanvang van de levering, rekenen wij u de vaste vergoeding voor zes maanden aan.
      </p>

      <p>
        Als u Uw Leveringsovereenkomst aan een variabele energieprijs en met een vaste vergoeding beëindigt meer dan zes maanden na de
        aanvang van de levering, rekenen wij u de vaste vergoeding aan naar rato van het aantal dagen dat wij u elektriciteit en/of aardgas
        leverden.{' '}
      </p>

      <p>
        Als Kleine Professionele Verbruiker bent u een opzegvergoeding verschuldigd wanneer u de Teurgleveringsovereenkomst vroegtijdig
        beëindigt. Deze vergoeding bestaat uit een vergoeding voor gederfde inkomsten en een vergoeding voor administratieve kosten.
      </p>

      <p>
        De vergoeding voor de gederfde inkomsten is gelijk aan de waarde van de niet teruggeleverde, doch gecontracteerde energievolumes,
        berekend aan de hand van de volgende formule:{' '}
      </p>

      <p>[(gecontracteerde, doch niet teruggeleverde energievolumes, uitgedrukt in MWh) * €/MWh]. </p>

      <p>
        Bij het ontbreken van een gecontracteerd volume zal deze voor wat betreft de niet uitgevoerde periode pro-rata, en volgens het
        S11-verbruiksprofiel berekend worden aan de hand van de effectief gemeten injectie gedurende de beleverde periode.{' '}
      </p>

      <p>De administratieve kosten bedragen 375,00 EUR per aansluitpunt.</p>

      <p>
        6.4. In overeenstemming met de van toepassing zijnde regelgeving kunnen wij de Leveringsovereenkomst en/of
        Terugleveringsovereenkomst van onbepaalde duur op elk moment beëindigen mits het respecteren van een opzegtermijn van twee maanden,
        of vijfenveertig dagen als uw leverpunt gelegen is in het Vlaamse Gewest
      </p>

      <p>
        6.5. De Leveringsovereenkomst loopt in alle gevallen door zolang Bolt in het toegangsregister vermeld staat als de verantwoordelijke
        voor de bevoorrading op uw Leverpunt.
      </p>

      <h3>7. Verbruik, Levering en Meting</h3>

      <p>7.1. Verbruik</p>

      <p>7.1.1. U zal de elektriciteit en/of het aardgas enkel op het Leverpunt verbruiken.</p>

      <p>
        7.1.2. Indien u toestellen gebruikt om zelf energie te produceren, moet u dit onmiddellijk aan ons melden. Als u dit wenst, kan u
        voor de door u op het net geïnjecteerde elektriciteit een Terugleveringsovereenkomst met Bolt sluiten. Wanneer u aan energiedelen of
        peer-to-peerhandel wil doen, moet u dit één maand voor de start van deze activiteit melden aan Bolt via e-mail.
      </p>

      <h3>7.2. Levering en Netbeheerder</h3>

      <p>
        7.2.1. Uw aansluiting op het net wordt door de Netbeheerder beheerd. De Netbeheerder is verantwoordelijk voor het functioneren van
        het net en de continuïteit van de Levering en de Teruglevering, en regelt de kwaliteit van de afname, de toevoer van elektriciteit
        en/of aardgas, de meetinrichting, de voor de aansluiting van de installaties relevante technische bepalingen evenals het aan- en
        afsluiten van de meters. Wij zijn geen partij bij deze relatie en zijn derhalve niet verantwoordelijk voor het nakomen van regels in
        die relatie door u of door de Netbeheerder.
      </p>

      <p>
        7.2.2. Indien de Netbeheerder de toevoer van elektriciteit en/of aardgas en/of de injectie van elektriciteit op het net beperkt of
        onderbreekt, zal de Levering en/of de Teruglevering automatisch eveneens beperkt of onderbroken worden. Deze beperking en/of
        schorsing valt buiten onze aansprakelijkheid.
      </p>

      <h3>7.3. Meting</h3>

      <p>
        7.3.1. De Netbeheerder bezorgt ons de stand van uw meter. Indien u ons de stand meedeelt, bent u verantwoordelijk voor de juiste
        opgave daarvan. De gegevens van de Netbeheerder hebben in elk geval voorrang.
      </p>

      <p>
        7.3.2. Zowel u als wij kunnen bij twijfel over de juistheid van de meting de meetinstallatie laten onderzoeken. Dit gebeurt op
        kosten van de verzoeker.
      </p>

      <p>
        7.3.3. Een rechtzetting van de meetgegevens en de daaruit voortvloeiende facturatie kan betrekking hebben op een periode van
        maximaal twee jaar voorafgaand aan de laatste meteropname, tenzij de toepasselijke regelgeving hierover iets anders zou bepalen.
      </p>

      <h3>8. Prijs en kosten</h3>

      <p>
        8.1. De prijs die u aan Bolt verschuldigd bent voor de Levering en/of de Energiediensten, bestaat uit (1) de energieprijs en/of de
        dienstverleningskost zoals bepaald in de BV, en (2) de andere bestanddelen van de prijs zoals bepaald in artikel 8.2.
      </p>

      <p>8.2. Tenzij anders bepaald wordt in de BV, de energieprijs en/of de dienstverleningskost verhoogd met:</p>

      <ul>
        <li>
          de BTW, belastingen, heffingen, retributies, bijdragen, toeslagen, vergoedingen, en eventuele andere lasten en kosten die ons door
          de bevoegde overheid of reguleringsinstantie worden opgelegd;
        </li>

        <li>
          de Nettarieven, meterhuurkosten, de kosten voor de aan- of afsluiting van het Leverpunt, de eventuele bijkomende diensten, het
          reactief vermogen en het piekvermogen die ons opgelegd worden door de Netbeheerder.
        </li>
      </ul>

      <p>
        De kosten van de wettelijke verplichtingen om groene stroom-, groene warmte-, warmtekracht- en/of analoge certificaten voor te
        leggen.Deze bestanddelen worden rechtstreeks aan u doorgerekend, met inbegrip van de wijzigingen die buiten de verantwoordelijkheid
        van Bolt vallen, ook met terugwerkende kracht.
      </p>

      <ul>
        <li>De kosten en vergoeding verbonden aan energiedelen of peer-to-peerverkoop.</li>
      </ul>

      <p>
        8.3. Wij mogen alle kosten aan u aanrekenen die ons door de Netbeheerder aangerekend worden voor diensten uitgevoerd op uw vraag, op
        initiatief van de Netbeheerder of op onze vraag ten gevolge van uw nalaten of fout. Eveneens mogen wij bovenop deze kosten onze
        administratieve kosten aan u aanrekenen.
      </p>

      <p>8.4. De Terugleveringsvergoeding die Bolt aan u is verschuldigd voor de Teruglevering, wordt bepaald in de BV.</p>

      <h3>9. Facturatie en betalingsvoorwaarden</h3>

      <p>
        9.1. Wij baseren ons conform artikel 7.3 op de meetgegevens die ons ter beschikking worden gesteld en op de door de Netbeheerder
        meegedeelde verbruiksprofielen om de door u afgenomen elektriciteit en/of aardgas te factureren. Wij sturen u maandelijkse
        voorschotfacturen. Wij kunnen steeds de hoogte van de voorschotfacturen wijzigen nadat wij u hierover informeerden via e-mail of een
        melding op de factuur. Deze wijziging is niet van toepassing op Huishoudelijke afnemers indien zij zich verzetten uiterlijk 15 dagen
        na deze melding. U kan steeds een wijziging van de hoogte van de voorschotfactuur aanvragen. Als u geen Huishoudelijke afnemer bent,
        zijn wij niet verplicht om gevolg te geven aan dat verzoek.
      </p>

      <p>
        De hoogte van die voorschotfacturen wordt door ons bepaald op basis van de door u verstrekte gegevens of op basis van de periodieke
        afrekening.{' '}
      </p>

      <p>
        Voor zover wij uw meetgegevens hebben ontvangen van de Netbeheerder, bezorgen wij u een factuur waarin we uw effectieve verbruik
        voor die periode afrekenen. Daarbij houden we rekening met de betaalde voorschotfacturen. Op uw uitdrukkelijk verzoek bezorgen we u
        de afrekeningsfactuur voor bepaalde periodes minstens meer dan eens per jaar.
      </p>

      <p>
        Indien wij geen meetgegevens ontvangen, kunnen wij u voorschotfacturen blijven sturen. Indien wij geschatte verbruiken ontvangen van
        de Netbeheerder, dan zullen wij dit geschatte verbruik effectief aanrekenen. Indien wij vaststellen dat de verbruiksgegevens foutief
        zijn, zullen wij dit melden aan de Netbeheerder en zullen wij u verder voorschotfacturen sturen. Uw effectieve verbruik zal dan
        later worden afgerekend.
      </p>

      <p>
        Als u over een digitale meter beschikt en wij de noodzakelijke meetgegevens hebben, kan u ons verzoeken om maandelijks een factuur
        op te sturen waarin wij uw werkelijk verbruik afrekenen.{' '}
      </p>

      <p>
        9.2. De betaling van onze facturen kan uitsluitend gebeuren op ons bankrekeningnummer vermeld op de factuur. U dient onze facturen
        uiterlijk binnen de 15 kalenderdagen na ontvangstdatum (indien de factuur wordt verstuurd per post, wordt deze geacht te zijn
        ontvangen op de derde dag na de verzending) te betalen. Indien u de factuur niet tijdig betaalt, zullen wij u minstens één
        herinnering sturen. Bij gebreke aan betaling binnen de in de herinnering voorziene termijn, sturen wij u een ingebrekestelling.
      </p>

      <p>
        Indien wij u een bedrag verschuldigd zijn, zullen we dit (terug)betalen binnen de betalingstermijn zoals bepaald in het eerste lid,
        tenzij:
      </p>

      <ul>
        <li>
          wij niet op de hoogte zijn van uw rekeningnummer (in welk geval wij de (terug)betaling zullen doen binnen de 15 kalenderdagen
          nadat wij op de hoogte werden gebracht van uw rekeningnummer);
        </li>

        <li>
          wij niet op de hoogte zijn van uw rekeningnummer, maar wel betalingen namens u ontvangen van een rekeningnummer, waarbij wij ervan
          mogen uitgaan dat we bevrijdend kunnen (terug)betalen op dat rekeningnummer; of
        </li>

        <li>
          wij op de hoogte zijn van uw rekeningnummer, maar de meest recente betalingen gebeurden van een ander rekeningnummer, waardoor we
          ervan mogen uitgaan dat we bevrijdend kunnen (terug)betalen op dat rekeningnummer; of
        </li>

        <li>u nog openstaande facturen heeft, waarbij wij het recht hebben dit te compenseren overeenkomstig de bestaande regelgeving.</li>
      </ul>

      <p>
        Er wordt geen bijkomende kost aangerekend indien u zich verzet tegen domiciliëring. U heeft de mogelijkheid om uw
        -afrekeningsfacturenen eindfactuur uit te sluiten van domiciliëring. De uitvoering van de domiciliëringsopdracht van de eindfactuur
        zal ten vroegste 15 kalenderdagen na datum van ontvangst van de eindfactuur gebeuren (de datum van ontvangst is de derde dag na het
        versturen van de factuur indien ze per post werd verstuurd en dezelfde dag als ze verstuurd werd per e-mail).
      </p>

      <p>
        9.3. De eventuele Terugleveringsvergoeding die Bolt u verschuldigd is voor de door u geïnjecteerde elektriciteit, wordt in onze
        afrekeningsfacturen en eindfactuur verrekend met de prijs die u aan Bolt verschuldigd bent voor de levering van de door u verbruikte
        elektriciteit. U betaalt het saldo aan Bolt of Bolt betaalt het saldo aan u, naargelang het geval.
      </p>

      <p>
        9.4. Indien u of wij van mening zijn dat onze factuur foutieve gegevens (andere dan de meetgegevens) bevat, moet binnen de 12
        maanden na ontvangst van de factuur schriftelijk contact met de andere partij worden opgenomen, behoudens wanneer de toepasselijke
        regelgeving een langere termijn voorziet. Indien de klacht over een factuur terecht is of verder moet worden onderzocht en indien de
        betreffende factuur nog niet werd betaald, mag u de betaling van het betwiste deel van de factuur opschorten tot de klacht is
        afgehandeld. Wij zullen zo vlug mogelijk na ontvangst van de klacht (of zo vlug mogelijk na ontvangst van de noodzakelijke
        informatie van een derde indien wij die informatie nodig hebben voor het beantwoorden van de klacht) ten gronde op de klacht
        antwoorden.
      </p>

      <p>
        9.5. Laattijdige betaling van één factuur door u heeft alsgevolg dat iedere andere factuur, ook al was daarvoor door ons een
        afbetalingsplan toegestaan, onmiddellijk opeisbaar is, zonder ingebrekestelling.
      </p>

      <p>
        9.6. Vanaf een vierde laattijdige betaling per kalenderjaar kunnen wij u een kost aanrekenen voor de daaropvolgende
        betalingsherinneringen. Elke herinnering kost 7, 50 euro, vermeerderd met de eventuele portokosten die van toepassing zijn op het
        ogenblik van de verzending. Als u een beschermde afnemer bent en uw leveringspunt gelegen is in het Vlaamse Gewest, rekenen wij u
        nooit kosten aan voor herinneringen.
      </p>

      <p>
        9.7. Bij niet-tijdige betaling van de gehele factuur of een deel ervan of indien een opdracht tot domiciliëring door de financiële
        instelling wordt geweigerd en wij u een ingebrekestelling in de vorm van een eerste herinnering verstuurden, bent u van rechtswege
        gehouden tot betaling van verwijlinteresten en voor zover uw leverpunt niet gelegen is in het Waalse Gewest, een forfaitaire
        vergoeding. De verwijlinteresten worden aangerekend vanaf 22 kalenderdagen die volgen op de dag waarop wij u de eerste herinnering
        verzonden, op elk onbetaald gelaten bedrag tot de datum van volledige betaling.
      </p>

      <p>
        Voor Huishoudelijke afnemers is de verwijlinterest de referentie-interestvoet vermeerderd met acht procentpunten, bedoeld in artikel
        5, tweede lid van de wet van 2 augustus 2002 betreffende de bestrijding van de betalingsachterstand bij de handelstransacties. Deze
        interesten worden berekend op de nog te betalen som. De Huishoudelijke afnemer betaalt bovendien de volgende forfaitaire vergoeding,
        waarvan het bedrag niet hoger is dan
      </p>

      <ol style={{ listStyleType: 'lower-latin' }}>
        <li>20 euro als het verschuldigde saldo lager dan of gelijk aan 150 euro is,</li>

        <li>
          30 euro vermeerderd met 10 % van het verschuldigde bedrag op de schijf tussen 150,01 en 500 euro als het verschuldigde saldo
          tussen 150,01 en 500 euro is,
        </li>

        <li>
          65 euro vermeerderd met 5 % van het verschuldigde bedrag op de schijf boven 500 euro met een maximum van 2000 euro als het
          verschuldigde saldo hoger dan 500 euro is.
        </li>
      </ol>

      <p>
        Voor Kleine Professionele Verbruikers is de verwijlinterest de referentie-interestvoet vermeerderd met acht procentpunten en
        afgerond tot het hogere halve procentpunt, bedoeld in artikel 5, tweede lid van de wet van 2 augustus 2002 betreffende de
        bestrijding van de betalingsachterstand bij de handelstransacties.
      </p>

      <p>
        Daarenboven bent u als Kleine Professionele Verbruiker, bij gebreke aan volledige betaling nadat wij uw onbetaalde factu(u)r(en)
        hebben overgemaakt aan een derde (bv. gerechtsdeurwaarder, advocaat of incassokantoor), van rechtswege en zonder verdere
        ingebrekestelling een forfaitaire schadeloosstelling verschuldigd van 10 % op elk onbetaald gelaten factuurbedrag, met een minimum
        van 55 EUR, dit ter vergoeding van de buitengerechtelijke invorderingskosten, in overeenstemming met de toepasselijke regelgeving,
        onverminderd ons recht om grotere schade en nadelen te bewijzen, onder meer door aanrekening van procedurekosten.
      </p>

      <p>
        9.8. Tenzij de gewestelijke reglementering een andere schadevergoeding zou voorzien, heeft u recht op verwijlinteresten op elk
        onbetaald gelaten bedrag aan de wettelijke interestvoet ingevolge foutieve facturatie door onze fout of onze laattijdige
        (terug)betaling. Deze interesten beginnen te lopen de dag na de dag waarop wij de betaling conform artikel 9.2 hadden moeten
        uitvoeren, of, in geval van foutieve facturatie door onze fout, vanaf de datum van protest door u, tot de datum van volledige
        betaling door ons. Tevens zijn dan de kosten van uw ingebrekestellingen en herinneringen voor onze rekening. Daarenboven heeft u
        recht op een forfaitaire schadeloosstelling van 10% van het dan onbetaalde bedrag voor zover u een derde (bv. gerechtsdeurwaarder,
        advocaat of incassokantoor) moet inschakelen om betaling ervan te bekomen met een minimum van 55 EUR, dit ter vergoeding van de
        buitengerechtelijke invorderingskosten, in overeenstemming met de toepasselijke regelgeving, onverminderd uw recht om grotere schade
        en nadelen te bewijzen, onder meer door aanrekening van procedurekosten.
      </p>

      <p>
        9.9. Indien de Leveringsovereenkomst wordt beëindigd, om welke reden ook, bezorgen wij u een eindafrekening. Als u de
        Leveringsovereenkomst opzegt en wij de nodige meetgegevens van de netbeheerder ontvingen, bezorgen wij u de eindafrekening ten
        laatste zes weken na uw opzeg.{' '}
      </p>

      <p>
        9.10. Indien u meent recht te hebben op het statuut van beschermde klant of op het sociaal tarief en dit niet automatisch wordt
        toegepast, moet u ons zo snel als mogelijk de nodige bewijzen en stukken bezorgen.
      </p>

      <h3>10. Aansprakelijkheid</h3>

      <p>
        10.1. Zonder afbreuk te doen aan de overige bepalingen inzake aansprakelijkheid in deze Leveringsovereenkomst en/of
        Terugleveringsovereenkomst en in de toepasselijke regelgeving, zijn u en wij ten opzichte van elkaar enkel aansprakelijk in geval
        van: rechtstreekse schade als het gevolg van een fout en in het geval van een overlijden of lichamelijk letsel van u veroorzaakt
        door een handeling of nalaten van Bolt.
      </p>

      <p>
        10.2. Behoudens in het geval dat u op basis van van toepassing zijnde regelgeving recht heeft op een voor u voordeligere
        schadevergoeding, zal de vergoeding van alle rechtstreekse schade maximaal gelijk zijn aan 12 maal de prijs van uw gemiddelde
        maandverbruik van de laatste zes maanden, of van de duur van de Leveringsovereenkomst en/of Terugleveringsovereenkomst zo deze
        korter is. Deze beperking is niet van toepassing in geval van overlijden of lichamelijk letsel van u veroorzaakt door een handeling
        of nalaten van Bolt.
      </p>

      <p>
        10.3. Elke aanspraak op schadevergoeding moet binnen 30 kalenderdagen na de datum waarop de schade is ingetreden of na de datum
        waarop de schade redelijkerwijs vastgesteld had kunnen worden, schriftelijk aan de andere partij worden gemeld. Laattijdige
        schademeldingen worden niet vergoed.
      </p>

      <p>
        10.4. Wij zijn niet aansprakelijk voor de schade veroorzaakt door het niet goed functioneren van het net, de installaties op het
        Leverpunt, de meetinrichting, fouten in meetgegevens, variaties in spanning en frequentie, tekortkomingen van de Netbeheerder, noch
        voor de gevolgen van het niet-nakomen van de afspraken tussen u en de Netbeheerder. Evenmin zijn wij aansprakelijk voor de kwaliteit
        van de uitgewisselde gegevens (zoals bijvoorbeeld standaard jaarverbruiken, synthetische lastprofielen). Dit alles is de
        verantwoordelijkheid van de Netbeheerder en staat los van de Leveringsovereenkomst en/of Terugleveringsovereenkomst.
      </p>

      <p>10.5. U zal ons vrijwaren voor eventuele vorderingen van derden, zoals uw commerciële relaties.</p>

      <p>
        10.6 Alle claims onder deze Leveringsovereenkomst en/of Terugleveringsovereenkomst kunnen uitsluitend tegen Bolt worden gericht. U
        doet afstand van elke buitencontractuele aansprakelijkheidsvordering tegen Bolt en onze verbonden vennootschappen, evenals tegen
        onze bestuurders, leidinggevende personen en personeel dat (hetzij via een arbeidsovereenkomst, hetzij als zelfstandige) betrokken
        is bij de uitvoering van deze Leveringsovereenkomst en/of Terugleveringsovereenkomst, ongeacht de specifieke schadeoorzaak.
      </p>

      <h3>
        11. Schorsing van de Levering en/of Teruglevering en onmiddellijke beëindiging van de Leveringsovereenkomst en/of
        Terugleveringsovereenkomst
      </h3>

      <p>
        11.1. In geval van ernstige tekortkoming door ons, mag u de Leveringsovereenkomst en/of Terugleveringsovereenkomst vroegtijdig
        beëindigen per aangetekende brief met onmiddellijke ingang en zonder rechterlijke tussenkomst.
      </p>

      <p>
        11.2. Wij mogen de Levering en/of de Teruglevering schorsen of de Leveringsovereenkomst en/of de Terugleveringsovereenkomst
        vroegtijdig beëindigen per schriftelijke kennisgeving met onmiddellijke ingang, zonder rechterlijke tussenkomst en zonder
        schadevergoeding, mits naleving van de toepasselijke regelgeving, indien:
      </p>

      <ol style={{ listStyleType: 'lower-latin' }}>
        <li>
          u tot vijftien dagen na de ingebrekestelling niet schriftelijk meedeelde welke regeling u wil treffen voor de betaling van uw
          openstaande rekeningen, u geen verplicht afbetalingsplan aanvaardt, u uw betalingsverplichtingen of andere verplichtingen na
          ingebrekestelling niet nakomt;
        </li>

        <li>wij u conform artikel 4.2 vragen om een waarborg te stellen, en u nalaat om (tijdig) deze waarborg te stellen;</li>

        <li>
          er een onderbreking of stopzetting van de Levering en/of de Teruglevering wordt opgelegd door de Netbeheerder of een bevoegde
          overheid;
        </li>

        <li>u fraudeert;</li>

        <li>
          u nalaat ons onmiddellijk in te lichten over ieder element waarvan u kennis heeft dat de uitvoering van de Leveringsovereenkomst
          en/of de Terugleveringsovereenkomst kan verhinderen of bemoeilijken.
        </li>
      </ol>

      <p>
        De beëindiging doet geen afbreuk aan ons recht op schadevergoeding. In geval van beëindiging overeenkomstig artikel 11.2 (d), zal
        deze schadevergoeding minstens gelijk zijn aan 3 maanden geschat verbruik. Indien onze schade groter is, zullen wij ook die kunnen
        verhalen. Onverminderd hetgeen bepaald is in artikel 9.5 en 9.6, bent u evenwel geen schadevergoeding verschuldigd indien wij
        beëindigen op grond van artikel 11.2. (a), (b), (c) of (e).
      </p>

      <p>
        11.3. In geval van een vroegtijdige beëindiging van de Leveringsovereenkomst door u of door ons, wordt de Leveringsovereenkomst
        steeds in zijn geheel beëindigd, m.a.w. voor zowel elektriciteit als voor aardgas. Desgevallend kan er daarna een nieuwe
        Leveringsovereenkomst worden gesloten voor elektriciteit of aardgas.
      </p>

      <p>
        11.4. Wanneer de Terugleveringsovereenkomst, al dan niet vroegtijdig, wordt beëindigd door u of door ons, heeft dit geen impact op
        de Leveringsovereenkomst, tenzij anders aangegeven door u of door ons. Wanneer de Terugleveringsovereenkomst, al dan niet
        vroegtijdig, wordt beëindigd door u of door ons, wordt de Leveringsovereenkomst ook beëindigd.
      </p>

      <p>
        11.5 De Leveringsovereenkomst loopt in alle gevallen door zolang Bolt in het toegangsregister vermeld staat als de verantwoordelijke
        voor de bevoorrading op uw Leverpunt.
      </p>

      <h3>12. Verhuis / overdracht</h3>

      <p>
        12.1. Bij verhuis blijft de Leveringsovereenkomst onverminderd van kracht op uw nieuwe adres. U dient ons bij voorkeur 30
        kalenderdagen op voorhand (en uiterlijk 30 kalenderdagen na de verhuisdatum voor Huishoudelijke afnemers en 10 kalenderdagen erna
        voor Kleine Professionele Verbruikers) op de hoogte te brengen van uw verhuisplannen en ons volgende informatie te bezorgen:
      </p>

      <ul>
        <li>uw toekomstige adres;</li>

        <li>EAN-nummer(s) en meternummer op dat adres;</li>

        <li>
          de datum vanaf wanneer er geleverd moet worden op het nieuwe Leverpunt en de Levering op uw huidige Leverpunt gestopt dient te
          worden; en de meterstanden van uw oude en nieuwe adres op het ogenblik van de verhuisdatum.
        </li>
      </ul>

      <p>
        U kan hiervoor gebruik maken van de communicatiekanalen die wij met het oog op verhuis ter beschikking stellen, o.a. ons
        energieovernamedocument.
      </p>

      <p>
        12.2. Indien u ons niet binnen de termijn bepaald in artikel 12.1 op de hoogte stelt van uw verhuis, blijft de Leveringsovereenkomst
        gelden op uw oude adres. Dit betekent dat u gehouden bent om alle elektriciteit en/of aardgas moet betalen die – door wie dan ook -
        wordt afgenomen op het Leverpunt dat u verlaat, tenzij de toepasselijke regelgeving in een andersluidende dwingende regeling
        voorziet. Indien u ons niet binnen de termijn bepaald in artikel 12.1 op de hoogte stelt van uw verhuis, neemt de
        Terugleveringsovereenkomst automatisch een einde op het moment van uw verhuis. Eventuele elektriciteit die – door wie dan ook –
        wordt geïnjecteerd op het Leverpunt dat u verlaat, wordt niet vergoed door Bolt, tenzij de toepasselijke regelgeving in een
        andersluidende dwingende regeling voorziet.
      </p>

      <p>
        12.3. Wij bezorgen u een factuur met de eindafrekening voor het Leverpunt dat u verlaat. Indien u ons niet binnen de termijn bepaald
        in artikel 12.1 de meterstand van het Leverpunt dat u verlaat, bezorgt, dan baseren wij ons op de meetgegevens van de netbeheerder.
      </p>

      <p>
        12.4. Indien u, mits voorlegging van het bewijs, verhuist naar het buitenland of naar een ander gewest, naar een woning waar er geen
        aparte meter is voor elektriciteit- en/of aardgasverbruik, gaat inwonen bij een andere verbruiker die reeds een
        leveringsovereenkomst (met ons of met een andere leverancier) heeft, verhuist naar een gebied waar wij om objectieve redenen niet
        (meer) in staat zijn om de Leveringsovereenkomst en/of de Terugleveringsovereenkomst verder te zetten, kan de Leveringsovereenkomst
        en/of de Terugleveringsovereenkomst door u of door ons opgezegd worden met ingang van de effectieve verhuisdatum.
      </p>

      <p>
        12.5. Wij leveren op uw nieuwe Leverpunt vanaf de datum die u ons meedeelde. De BV van de Leveringsovereenkomst en/of de
        Terugleveringsovereenkomst kunnen worden aangepast als dit technisch noodzakelijk is.{' '}
      </p>

      <p>
        12.6. Indien u de bovenstaande verplichtingen bij uw verhuis niet naleeft, geeft u ons een mandaat om bij de netbeheerder de
        sluiting van de meter op het Leverpunt dat u verlaat, te vragen. U staat dan in voor alle kosten van de sluiting. Wij zijn niet
        aansprakelijk voor de schade die in dat geval wordt veroorzaakt.
      </p>

      <h3>13. Wijzigingen aan de Leveringsovereenkomst en/of Terugleveringsovereenkomst</h3>

      <p>
        13.1. Voor zover deze wijzigingen niet in uw nadeel zijn, mogen wij op elk moment wijzigingen aanbrengen aan de
        Leveringsovereenkomst en/of de Terugleveringsovereenkomst. Wij zullen u desgevallend deze gewijzigde voorwaarden ten minste twee
        maanden voor het inwerkingtreden ervan op geïndividualiseerde wijze meedelen. Als mededeling geldt onder meer de melding per brief,
        op de factuur, per e-mail of via een andere duurzame drager.
      </p>

      <p>
        13.2. Indien uw Leveringsovereenkomst en/of uw Terugleveringsovereenkomst van onbepaalde duur is, kunnen wij bovendien op elk
        moment:
      </p>

      <ul>
        <li>prijsverhogingen doorvoeren in het geval van een Leveringsovereenkomst;</li>

        <li>de Terugleveringsvergoeding verlagen in het geval van een Terugleveringsovereenkomst;</li>

        <li>of andere wijzigingen in uw nadeel aanbrengen</li>
      </ul>

      <p>
        mits wij u hiervan minstens twee maanden voor het inwerkingtreden ervan informeren op dezelfde wijze als bepaald in artikel 13.1.
      </p>

      <p>
        U zal geacht worden deze wijzigingen aanvaard te hebben, tenzij u binnen de maand na ontvangst van de mededeling de
        Leveringsovereenkomst (in geval van wijzigingen aan de Leveringsovereenkomst) en/of de Terugleveringsovereenkomst (in geval van
        wijzigingen aan de Terugleveringsovereenkomst) opzegt conform artikel 6.3. In geval van mededeling per e-mail, is de dag van
        ontvangst de dag van verzending van de e-mail; indien de mededeling wordt verstuurd per post, wordt deze geacht te zijn ontvangen op
        de derde dag na de verzending.
      </p>

      <p>
        13.3. Indien, de Bijzondere Voorwaarden in onderling overleg worden gewijzigd, zal een nieuwe Leveringsovereenkomst en/of
        Terugleveringsovereenkomst tot stand komen zodra wij deze wijziging in onze systemen hebben verwerkt. Wij brengen u van deze datum
        op de hoogte.
      </p>

      <p>
        13.4. Wij mogen de Leveringsovereenkomst en/of de Terugleveringsovereenkomst overdragen aan een derde en zullen u in dat geval
        inlichten. Deze derde zal de Leveringsovereenkomst en/of de Terugleveringsovereenkomst onder dezelfde voorwaarden verder zetten. U
        mag de Leveringsovereenkomst en/of de Terugleveringsovereenkomst niet overdragen aan een derde, een medebewoner of een nieuwe
        bewoner.
      </p>

      <h3>14. Wijziging Producent Elektriciteit</h3>

      <p>
        14.1. De koppeling tussen u en de Producent Elektriciteit is gebaseerd op gemiddelden van uw verbruik en de productie van de
        Producent Elektriciteit. Beperkte schommelingen in uw verbruik en de productie van de Producent Elektriciteit zullen worden
        opgevangen met elektriciteit afkomstig van andere producenten die bij ons platform zijn aangesloten, die eveneens lokale en groene
        elektriciteit produceren.
      </p>

      <p>
        14.2. Indien de Producent Elektriciteit niet meer beschikbaar is op ons platform of structureel niet meer voldoende elektriciteit
        produceert om in uw elektriciteitsverbruik te voorzien (naast dat van de andere klanten die voor deze Producent Elektriciteit hebben
        gekozen), zal Bolt u hiervan schriftelijk op de hoogte brengen per brief of per e-mail. Wij stellen u dan een nieuwe producent voor
        ter vervanging van uw Producent Elektriciteit. Vanaf deze melding, beschikt u over één maand om ons een andere keuze voor een nieuwe
        producent mee te delen via brief of e-mail. Deze termijn van één maand gaat in vanaf de dag van verzending van onze e-mail of vanaf
        de derde dag na de verzending van onze brief. Indien u ons uw keuze voor een andere nieuwe producent niet meedeelt en u ook niet van
        leverancier verandert binnen deze termijn, zullen wij de door ons voorgestelde producent aan u koppelen.
      </p>

      <p>
        14.3. De wijziging van de Producent Elektriciteit overeenkomstig artikel 14.2., zal niet worden beschouwd als een wijziging van de
        Leveringsovereenkomst.
      </p>

      <h3>15. Evenwichtsverantwoordelijkheid</h3>

      <p>Voor de evenwichtsverantwoordelijkheid, zowel voor de Levering als voor de Teruglevering, doet Bolt een beroep op [Luminus NV].</p>

      <h3>16. Overmacht</h3>

      <p>
        16.1. Ingeval van overmacht worden de verplichtingen onder deze Leveringsovereenkomst en/of Terugleveringsovereenkomst, behalve de
        verplichting tot betaling van een geldsom, geschorst of beperkt gedurende de periode van de overmacht. Onder overmacht dient te
        worden verstaan: elke onvoorzienbare en onvermijdbare gebeurtenis die onafhankelijk is van de wil van een partij die een
        onoverkomelijk beletsel uitmaakt voor de nakoming van de verbintenis van die partij, zoals maar niet beperkt tot, uitval van het
        net, problemen in het transport of de distributie, het niet kunnen verkrijgen van (voldoende) elektriciteit of aardgas,
        natuurrampen, stakingen.
      </p>

      <p>
        16.2. Indien de overmachtssituatie meer dan drie maanden aanhoudt, hebben zowel u als wij het recht om de Leveringsovereenkomst
        en/of Terugleveringsovereenkomst schriftelijk te beëindigen, zonder dat schadevergoeding verschuldigd is aan de andere partij.
      </p>

      <h3>17. Bescherming van de persoonlijke levenssfeer</h3>

      <p>
        Als verantwoordelijke voor de verwerking van uw persoonsgegevens, verwerken wij uw persoonsgegevens steeds in overeenstemming met de
        toepasselijke privacyregelgeving. Wij verwerken uw persoonsgegevens voor doeleinden en rechtsgronden beschreven in ons privacybeleid
        zoals vermeld op onze website www.boltenergie.be onder de rubriek “Disclaimer en Privacy Policy” (hierna ‘het Privacybeleid’). Door
        uitdrukkelijk in te stemmen en akkoord te gaan met de Leveringsovereenkomst en/of Terugleveringsovereenkomst, bevestigt u kennis te
        hebben genomen van het Privacybeleid en akkoord te gaan met de verwerking van uw persoonsgegevens overeenkomstig het Privacybeleid.
      </p>

      <h3>18. Geen afstand van recht</h3>

      <p>
        Het niet-aandringen op de uitvoering van enige bepaling van de Leveringsovereenkomst en/of de Terugleveringsovereenkomst, kan niet
        worden opgevat als een afstand van recht of een beperking daarvan.
      </p>

      <h3>19. Onafdwingbare bepalingen</h3>

      <p>
        Indien een bepaling van de Leveringsovereenkomst en/of de Terugleveringsovereenkomst ongeldig of nietig zou zijn, zal dit geen
        invloed hebben op de geldigheid van de andere bepalingen van de Leveringsovereenkomst en/of de Terugleveringsovereenkomst, maar zal
        deze ongeldige of nietige bepaling naar best vermogen vervangen worden door een geldige bepaling die zo nauw mogelijk aansluit bij
        de oorspronkelijke bedoeling van de partijen.
      </p>

      <h3>20. Toepasselijk recht en geschillen – klachten</h3>

      <p>20.1. Het Belgisch recht is van toepassing op de Leveringsovereenkomst en/of de Terugleveringsovereenkomst.</p>

      <p>
        20.2. Voor klachten kan u zich wenden tot onze klantendienst, waarvan u de contactgegevens kan terugvinden op uw factuur of op onze
        website. Indien uw Leveringsovereenkomst en/of Terugleveringsovereenkomst elektronisch werd afgesloten, kan u beroep doen op het
        ODR-platform voor onlinebeslechting van uw geschillen (
        <a rel="noreferrer noopener" href="http://ec.europa.eu/consumers/odr/">
          http://ec.europa.eu/consumers/odr/
        </a>
        ). U kan zich ook richten tot de bevoegde federale en regionale diensten.
      </p>

      <p>
        20.3. Geschillen omtrent de Leveringsovereenkomst en/of de Terugleveringsovereenkomst kunnen naar keuze van de eisende partij worden
        gebracht voor de rechter van de woonplaats van de verwerende partij of voor de rechter van de plaats waar de verbintenis waarop het
        geschil betrekking heeft, is ontstaan of waar zij moet worden uitgevoerd.
      </p>

      <p>MODELFORMULIER HERROEPING</p>

      <p>
        Dit formulier alleen invullen en aan Bolt bezorgen als je je Leveringsovereenkomst en/of je Terugleveringsovereenkomst wil
        herroepen.
      </p>

      <p>Gelieve dit document terug te bezorgen aan Bolt:</p>

      <p>Via post: (adres aanvullen)</p>

      <p>Via e-mail: (e-mail aanvullen)</p>

      <p>
        Ik deel u mee dat ik de Leveringsovereenkomst voor de levering van elektriciteit / gas en/of de Terugleveringsovereenkomst voor
        elektriciteit* wil herroepen. (Schrappen wat niet past).
      </p>

      <p>Productnaam:</p>

      <p>Datum bevestiging Leveringsovereenkomst en/of Terugleveringsovereenkomst:</p>

      <p>
        In het geval de Leveringsovereenkomst en/of Terugleveringsovereenkomst telefonisch gesloten werd: de datum dat u de
        Leveringsovereenkomst en/of Terugleveringsovereenkomst bevestigd heeft.
      </p>

      <p>In alle andere gevallen: de datum dat Bolt de Leveringsovereenkomst en/of Terugleveringsovereenkomst bevestigd heeft.</p>

      <p>Naam Klant:</p>
      <p>Adres Klant:</p>
      <p>Datum:</p>
      <p>Handtekening:</p>

      <h3>
        <u>BRUSSEL:</u>
      </h3>

      <h4>
        Bolt reproduceert hieronder de openbare dienstverplichtingen met betrekking tot de levering aan beschermde klanten. Overeenkomstig
        de Ordonnantie van 19 juli 2001 betreffende de organisatie van de elektriciteitsmarkt in het Brussels Hoofdstedelijk Gewest, en de
        Ordonnantie van 1 april 2004 betreffende de organisatie van de gasmarkt in het Brussels Hoofdstedelijk Gewest.
      </h4>

      <h3>ELEKTRICITEIT: HOOFDSTUK IVbis. Openbare dienstverplichtingen betreffende de levering van elektriciteit. </h3>

      <p>
        Art. 25ter § 1. De leverancier maakt, aan elke afnemer die erom verzoekt, binnen tien werkdagen een redelijk en niet-discriminerend
        voorstel van leveringscontract over en deelt hem de algemene leveringsvoorwaarden mee evenals, met name wanneer de afnemer een
        huishoudelijke afnemer is, de bepalingen van deze ordonnantie die betrekking hebben op de beschermde afnemers. Deze verplichting
        berust op de leverancier voor alle soorten meetregimes.
      </p>

      <p>
        De leverancier maakt aan elke eindafnemer met een slimme meter die hierom verzoekt binnen tien werkdagen een redelijk en
        niet-discriminerend voorstel van leveringscontract op basis van een dynamische elektriciteitsprijs over. Naast de informatie vermeld
        in het eerste lid, delen de leveranciers in het voorstel van leveringscontract op basis van een dynamische elektriciteitsprijs de
        mogelijkheden, kosten, risico&apos;s en verplichtingen mee die verbonden zijn aan een leveringscontract op basis van een dynamische
        elektriciteitsprijs, met inbegrip van de noodzaak een slimme meter te hebben.
      </p>

      <p>
        Leveranciers die minder dan 200.000 eindafnemers op nationaal niveau hebben, zijn vrijgesteld van de verplichting vermeld in het
        vorige lid.
      </p>

      <p>
        Indien de vraag uitgaat van een afnemer of een voormalige afnemer die zijn schulden bij de betrokken leverancier niet volledig heeft
        gezuiverd en die het eventueel opgesteld afbetalingsplan niet heeft nageleefd, kan de leverancier ofwel schriftelijk weigeren om een
        voorstel tot leveringscontract te doen ofwel schriftelijk een voorstel tot leveringscontract verzenden dat wordt gesloten nadat de
        afnemer een borg heeft verschaft.
      </p>

      <p> ...</p>

      <p>
        § 2. De leveranciers delen de algemene voorwaarden alsook elke wijziging daarvan inzake de leveringscontracten mee aan Brugel, zodat
        de regulator hun conformiteit met de Brusselse wetgeving kan controleren.
      </p>

      <p>
        Indien de in het vorige lid opgesomde documenten niet worden bezorgd, worden sancties voorzien. De Regering legt de modaliteiten
        daarvan vast.
      </p>

      <p></p>

      <p>
        Art. 25ter/1. Voor wat betreft de contracten voor elektriciteitslevering die uitsluitend bestemd zijn voor de elektrische
        bevoorrading van oplaadpunt zijn de openbaredienstverplichtingen opgenomen in de artikelen 25quater, vierde lid, 25sexies,
        25septies, 25octies, 25decies, 25undecies en 25tredies niet van toepassing.{' '}
      </p>

      <p>
        Art. 25quater De leveranciers waarborgen de gezinnen een minimale ononderbroken levering van elektriciteit voor het verbruik van het
        gezin tegen niet-discriminerende voorwaarden. Wordt beschouwd als discriminerend, elk verschil in behandeling dat niet redelijk
        verantwoord kan worden en dat met name steunt op het statuut, het inkomstenniveau of de woonplaats. ...
      </p>

      <p>
        Deze bevoorrading is niet voorzien voor de gemeenschappelijke ruimtes van woongebouwen, noch voor tweede woningen, noch voor
        woningen die onbewoond zijn.
      </p>

      <p>
        Voor gemeenschappelijk gebouw met gemeenschappelijke verwarmingsketel legt de Regering de regels van de verplichting betreffende
        deze minimale ononderbroken elektriciteitsbevoorrading vast.
      </p>

      <p>
        Onder voorbehoud van een federale norm die gunstiger is voor de verbruiker, ... en onder voorbehoud van de in dit hoofdstuk
        vastgestelde opzeggingstermijnen, worden de leveringscontracten gesloten voor een vaste periode van minimum drie jaar.
      </p>

      <p> Een gezin kan ze evenwel altijd opzeggen mits een opzeggingstermijn van maximum drie weken..</p>

      <p> Art. 25quinquies. (…)</p>

      <br />

      <p>
        Art. 25sexies § 1. De niet-betaling van het gefactureerde bedrag voor het elektriciteitsverbruik maakt het voorwerp van een
        herinnering door de leverancier uit binnen de 15 dagen na de vervaldatum van de factuur. In geval van niet-betaling van het
        gefactureerde bedrag, stuurt de leverancier een ingebrekestelling per aangetekende brief en per gewone brief binnen ten vroegste 15
        dagen en ten laatste 30 dagen na de verzending van de herinnering. Bij ontstentenis van betaling binnen zeven dagen vanaf de
        ontvangst van de ingebrekestelling stelt de leverancier een redelijk afbetalingsplan aan het gezin voor en stelt de
        distributienetbeheerder in kennis van zijn voornemen om de procedure tot beëindiging van het leveringscontract op te starten. De
        leverancier licht eveneens het gezin in over zijn voornemen om het O.C.M.W. van de gemeente waar het leveringspunt zich bevindt in
        te lichten, met name om hem toe te laten de bijstand ervan te genieten bij het onderhandelen over zijn afbetalingsplan, evenals over
        zijn recht om de mededeling van zijn naam aan het O.C.M.W. te weigeren, door aangetekende brief, gericht aan de leverancier, binnen
        de tien dagen. Deze mededeling gebeurt in de vorm van een listing met de contactgegevens van de betrokken afnemers van de
        leverancier, opgesteld overeenkomstig het door Brugel vastgelegde model en met de door hem vastgelegde frequentie. De leverancier
        deelt het gezin zijn voorstel van afbetalingsplan schriftelijk mee, indien het gezin hem daarom verzoekt; hij deelt het gezin het
        tussen hen overeengekomen afbetalingsplan ambtshalve schriftelijk mee. Het gezin, of het O.C.M.W. op verzoek van het gezin, kan ook
        een afbetalingsplan voorstellen aan de leverancier.
      </p>

      <p>
        Het redelijk karakter van het afbetalingsplan, met name de duur en het bedrag van de gespreide betalingen, wordt beoordeeld in
        functie van het evenwicht dat het tot stand doet komen tussen het belang van de leverancier om zijn schuld terugbetaald te krijgen
        binnen een redelijke termijn en het belang van de afnemer om zijn schuld te vereffenen binnen een termijn die aangepast is aan zijn
        financiële situatie. Een afbetalingsplan is niet redelijk als het de afnemer en zijn gezin niet in de mogelijkheid stelt een
        menswaardig bestaan te leiden. Indien het gezin wordt bijgestaan door een erkend centrum voor schuldbemiddeling of door het
        O.C.M.W., dan zal deze instantie opnieuw onderhandelen over het afbetalingsplan indien ze vaststelt dat het niet of niet langer
        redelijk is. De minimuminformatie die elk afbetalingsplan moet vermelden, wordt gespecificeerd in bijlage 3.
      </p>

      <p> Bij overdracht van schuldvordering door de leverancier :</p>

      <p>
        1° de overdracht is slechts tegenwerpelijk aan de overgedragen schuldenaar vanaf het ogenblik dat de overgedragen schuldenaar
        hiervan per aangetekende brief in kennis werd gesteld of door hem werd erkend. Ingeval een gerechtelijke procedure wordt ingeleid,
        moet de kennisgeving gebeuren twee maanden voordat de overnemer een gerechtelijke procedure tegen hem kan instellen;
      </p>

      <p>
        2° de overnemer blijft gebonden aan dezelfde verplichtingen als de overdrager met inbegrip van die opgelegd in deze ordonnantie en
        in de artikelen 591, 215° en 628, 25° van het Gerechtelijk Wetboek;
      </p>

      <p>3° de overnemer blijft gebonden aan zijn informatieplicht, zowel ten overstaan van de overdrager als van de eindafnemer.</p>

      <p>
        § 2. Overeenkomstig artikel 5 van de wet van 20 december 2002 betreffende de minnelijke invordering van de schulden van de
        consument, mag aan de verbruiker geen andere vergoeding gevraagd worden dan de bedragen bepaald in het contract.
      </p>

      <p>
        Op voorwaarde dat die contractueel vastgelegd zijn, mag geen enkel bedrag ander dan die hieronder aangegeven van de verbruiker
        geëist worden :
      </p>

      <p>
        1° alle invorderingskosten voor onbetaalde facturen, mogen 7,50 euro voor een herinnering en 15 euro voor ingebrekestelling niet
        overschrijden, met dien verstande dat het totaal van de invorderings- en administratieve kosten de som van 55 euro per
        leveringscontract niet mag overschrijden. De Regering kan deze forfaitaire sommen aanpassen in rekening met het indexcijfer van de
        consumptieprijzen te houden. Voor de toepassing van dit punt :
      </p>

      <p>
        a) het maximum van 55 euro is van toepassing tijdens de minnelijke invorderingsprocedure, vanaf het moment dat de eerste aanmaning
        tot betaling wordt verzonden, en eindigt wanneer de schuld volledig is betaald of wanneer de zaak wordt doorverwezen naar de
        vrederechter ;
      </p>

      <p>
        b) onder &quot; totale invorderings- en administratiekosten &quot; wordt verstaan : de aanmanings- en ingebrekestellingskosten, de
        contractuele verwijlinteresten, de boeteclausule of de kosten van een derde die een activiteit van minnelijke invordering van
        schulden uitoefent ;
      </p>

      <p> 2° het verschuldigde resterende saldo;</p>

      <p> 3° ...</p>

      <p>
        Zodra de ontbindingsprocedure wordt ingeleid, zullen geen andere herinnerings- en ingebrekestellingskosten mogen worden geëist. ...
      </p>

      <p>
        § 3. Van zodra de leverancier hem in kennis heeft gesteld van zijn voornemen om de procedure tot beëindiging van het
        leveringscontract op te starten en ten laatste tien dagen na de ontvangst van deze informatie, waarschuwt de distributienetbeheerder
        de eindafnemer voor de gevolgen van het niet-betalen van het gefactureerde bedrag. Hij informeert hem ook over het bestaan van het
        beschermingssysteem van artikelen 25sexies tot en met 25octies en stuurt hem de contactgegevens van het O.C.M.W. van zijn woonplaats
        en van het informatiecentrum voor afnemers van gas en elektriciteit bedoeld in artikel 33bis. Die informatie wordt verstrekt in
        duidelijke en begrijpelijke taal.
      </p>

      <p>
        § 4. In geen geval mag een leveringspunt van elektriciteit dat bestemd is voor een hoofdwoonplaats of voor hoofdzakelijk
        huishoudelijk gebruik worden afgesloten zonder de goedkeuring van de vrederechter.
      </p>

      <p>
        Deze bepaling is niet van toepassing wanneer de afsluiting vereist is omdat de veiligheid van goederen of personen, of de goede
        werking van het distributienetwerk ernstig in het gedrang komt.
      </p>

      <p>
        Iedere afsluiting zonder de instemming van de vrederechter op basis van dit artikel maakt het voorwerp uit van een
        informatiemaatregel via aangetekende zending, met vermelding voor de verbruiker van de precieze redenen die tot die afsluiting
        geleid hebben, alsook de duur ervan. Een kopie van de brief wordt naar Brugel gestuurd.
      </p>

      <p>
        Bovendien, als de distributienetbeheerder door een leverancier belast wordt met het afsluiten van een afnamepunt dat niet gedekt is
        door een contract of niet standaard beleverd wordt, neemt hij de nodige maatregelen om de mogelijke aanwezigheid van een eindafnemer
        vast te stellen en nodigt hij deze uit zijn contractuele situatie binnen de veertig dagen in orde te brengen. Deze maatregelen
        bestaan uit een administratief onderzoek, gevolgd door een kort onderzoek ter plaatse als de eindafnemer zijn situatie niet in regel
        brengt. Bij gebrek aan regularisatie door de eindafnemer binnen deze termijn van veertig dagen of zodra de afwezigheid van een
        eindafnemer is bevestigd, is de toestemming van de vrederechter voor de afsluiting niet langer vereist. In het kader van het
        administratief onderzoek vraagt de distributienetbeheerder de nodige gegevens voor de identificatie van de eigenaar van de plaats
        van verbruik aan de Algemene Administratie van de Patrimoniumdocumentatie op grond van artikel 36, 1°, van het koninklijk besluit
        van 30 juli 2018 betreffende het aanleggen en bijhouden van de kadastrale documentatie en tot vaststelling van de modaliteiten voor
        het afleveren van kadastrale uittreksels. De modaliteiten van het administratief onderzoek en van het onderzoek ter plaatse worden
        door Brugel en de distributienetbeheerder in onderling overleg bepaald.
      </p>

      <p>
        Wanneer de distributienetbeheerder door een leverancier wordt belast met het afsluiten van een afnamepunt dat niet gedekt is door
        een contract of niet standaard beleverd wordt, en uit het administratief onderzoek of het in het vierde lid bedoelde onderzoek ter
        plaatse blijkt dat de eindafnemer de laatste bewoner is die gekend is bij de distributienetbeheerder, dan sluit de
        distributienetbeheerder het afnamepunt niet af en vraagt hij de leverancier om de afsluitingsaanvraag te annuleren. De
        distributienetbeheerder brengt Brugel hiervan op de hoogte.
      </p>

      <p>
        § 5. Tenzij het gezin vroeger de mededeling van zijn naam heeft geweigerd overeenkomstig paragraaf 1, kan het O.C.M.W. een
        maatschappelijk onderzoek bij het gezin in kwestie uitvoeren en begeleidingsmaatregelen voor het gezin voorstellen, eventueel met de
        hulp van een schuldbemiddelingsdienst.
      </p>

      <p>
        § 6. Als het gezin weigert zijn naam aan het O.C.M.W. mee te delen, als er geen afbetalingsplan wordt overeengekomen met of zonder
        de begeleiding van het O.C.M.W. of als het betalingsplan niet wordt nageleefd, kan de leverancier een brief sturen naar het gezin
        met de mededeling dat, indien het niet binnen vijftien kalenderdagen betaalt, het afbetalingsplan opnieuw volgt of geen bewijs
        levert dat het een beschermde afnemer is, de vrederechter toestemming zal worden gevraagd om het contract op te zeggen en de stroom
        af te sluiten.
      </p>

      <p> § 7. ...</p>

      <p> § 8. ...</p>

      <p> § 9. ...</p>

      <p>
        Art. 25septies. § 1. Vanaf de ingebrekestelling, wordt het gezin dat het vraagt erkend als beschermde afnemer indien het één of
        meerdere van de volgende voorwaarden vervult :
      </p>

      <p> 1° het geniet van het specifiek sociaal tarief;</p>

      <p>
        2° het maakt gebruik van een procedure voor schuldbemiddeling met een erkend centrum voor schuldbemiddeling of een collectieve
        schuldenregeling;
      </p>

      <p> 3° het geniet de verhoogde tussenkomst.</p>

      <p>
        § 1bis. Het gezin bedoeld in paragraaf 1, 1°, waarvan het schuldbedrag hoger is dan 150 euro voor de elektriciteitsfactuur of 250
        euro voor de enkele factuur voor beide energieën, wordt automatisch erkend als beschermde afnemer zestig dagen na de verzending van
        de ingebrekestelling, tenzij het gezin bezwaar maakt zoals bedoeld in het tweede lid.
      </p>

      <p>
        Vanaf de ingebrekestelling stelt de leverancier het gezin in kennis van deze procedure, waarna het gezin bezwaar kan maken tegen de
        automatische toekenning van het statuut van beschermde afnemer.
      </p>

      <p>
        Vanaf de automatische toekenning van dat statuut stelt de leverancier de noodleverancier in kennis en wordt de beschermde afnemer
        door laatstgenoemde bevoorraad, voor zover het gezin nog steeds aan de in het eerste lid vastgestelde voorwaarden voldoet.
      </p>

      <p>
        De Regering kan de bovengenoemde voorwaarden en modaliteiten aanpassen en aanvullen en de categorie van begunstigden van de
        procedure voor de automatische toekenning van het statuut van beschermde afnemer uitbreiden op basis van een evaluatie van het
        aantal gezinnen dat overeenkomstig die procedure als beschermde afnemer wordt erkend.
      </p>

      <p>
        § 2. - Vanaf de ingebrekestelling, op verzoek van de afnemer en na het sociale onderzoek, kan het O.C.M.W. eveneens het statuut van
        beschermde afnemer aan het gezin toekennen. Vanaf de verkrijging van dit statuut, brengt het O.C.M.W. de noodleverancier hiervan op
        de hoogte en wordt de beschermde afnemer door laatstgenoemde beleverd.
      </p>

      <p>
        § 3. Indien het gezin aan geen enkele van de in § 1 van dit artikel opgesomde voorwaarden voldoet, kan het zich vanaf de
        ingebrekestelling tot Brugel richten om dit statuut te verkrijgen. De toekenningscriteria houden rekening met de inkomsten
        overeenkomstig de leden 2 tot 5 en het aantal personen in het gezin.
      </p>

      <p>
        De samengevoegde inkomsten van alle leden van het gezin dat kandidaat is voor het in lid 1 bedoelde statuut van beschermde afnemer
        mogen, voor een gegeven belastingjaar, niet hoger zijn dan 37.600 euro. Deze inkomsten omvatten niet deze van de kinderen ten laste,
        zijnde kinderen waarvoor kinderbijslag of wezenbijslag wordt uitbetaald aan een lid van dit gezin. Deze inkomsten houden rekening
        met het kadastraal inkomen van de in België of in het buitenland gelegen onroerende goederen, al dan niet bewoond als
        hoofdverblijfplaats, verminderd met een bedrag van 745 euro.
      </p>

      <p>
        Voor de gezinnen waarvan ten minste twee leden op de datum van de indiening van de aanvraag beroepsinkomsten ontvangen in de zin van
        het Wetboek van de Inkomstenbelastingen, wordt het in lid 2 bedoelde bedrag verhoogd tot 52.600 euro.
      </p>

      <p>
        Voor elk lid van het in lid 1 bedoelde kandidaat-gezin dat door de fiscale wetgeving wordt beschouwd als persoon ten laste, worden
        de in de leden 2 en 3 bedoelde bedragen verhoogd. Deze verhoging bedraagt 3.000 euro voor de eerste persoon ten laste en 1.500 euro
        voor de volgende personen ten laste.
      </p>

      <p>
        Deze bedragen zijn gekoppeld aan de evolutie van de prijsindex overeenkomstig het mechanisme dat is vastgelegd door de wet van 2
        augustus 1971 houdende inrichting van een stelsel waarbij de wedden, lonen, pensioenen, toelagen en tegemoetkomingen ten laste van
        de openbare schatkist, sommige sociale uitkeringen, de bezoldigingsgrenzen waarmee rekening dient gehouden bij de berekening van
        sommige bijdragen van de sociale zekerheid der arbeiders, alsmede de verplichtingen op sociaal gebied opgelegd aan de zelfstandigen,
        aan het indexcijfer van de consumptieprijzen worden gekoppeld.
      </p>

      <p>
        Brugel voert jaarlijks een evaluatie uit van de aan de eindafnemers aangerekende prijzen en van de weerslag van de evolutie van die
        prijzen op het aantal gezinnen dat kandidaat is voor het in lid 1 bedoelde statuut van beschermde afnemer en op de overeenkomstig de
        leden 2, 3 en 4 vastgestelde bedragen van de inkomsten. De eerste evaluatie wordt uiterlijk op 1 januari 2023 aan de regering
        meegedeeld.
      </p>

      <p>
        Op basis van de in lid 6 bedoelde evaluatie kan de regering de in de leden 2, 3 en 4 bedoelde bedragen van de inkomsten wijzigen.
      </p>

      <p>
        De regering kan bepalen welk soort inkomen in overweging moet worden genomen en welke procedure Brugel moet volgen voor het
        verkrijgen van het statuut van beschermde afnemer. Vanaf het verkrijgen van dat statuut, brengt Brugel de noodleverancier hiervan op
        de hoogte en wordt de beschermde afnemer door laatstgenoemde beleverd.
      </p>

      <p>
        § 3bis. Het gezin wordt erkend als een beschermde afnemer voor een bepaalde duur van maximaal vijf jaar, onder voorbehoud van de
        toepassing van paragraaf 6. Indien een gezin dat als beschermde afnemer is erkend, betrokken raakt bij een schuldbemiddelingsproces
        met een erkend bemiddelingscentrum of een collectieve schuldenrekening, wordt het voor onbepaalde tijd erkend als beschermde
        afnemer, onder voorbehoud van de toepassing van paragraaf 6.
      </p>

      <p>
        § 4. Zodra het gezin het statuut van beschermde afnemer heeft, wordt het contract dat met de leverancier werd gesloten opgeschort en
        kan de leverancier de vrederechter niet om de ontbinding van het contract vragen tijdens de duur van de opschorting. Zodra hij het
        bewijs heeft ontvangen dat het gezin beschermd is, levert de netbeheerder aan het gezin als noodleverancier. Indien de
        noodleverancier het gezin voorziet van elektriciteit en gas, is artikel 25undecies, tweede lid van toepassing. Het afbetalingsplan
        kan heronderhandeld worden en wordt door de leverancier aan de noodleverancier meegedeeld.
      </p>

      <p>
        § 5. Elke &quot; beschermde afnemer &quot; is een &quot; kwetsbare afnemer &quot; in de zin van richtlijn (EU) 2019/944 van het
        Europees Parlement en de Raad van 5 juni 2019 betreffende gemeenschappelijke regels voor de interne markt voor elektriciteit en tot
        wijziging van richtlijn 2012/27/EU.
      </p>

      <p>
        § 6. Zodra het gezin alle schuld heeft aangezuiverd in naleving van het afbetalingsplan deelt de leverancier dit mee aan de
        noodleverancier. Het gezin wordt niet meer erkend als beschermde afnemer en de opschorting van het contract zoals bedoeld in § 4
        wordt beëindigd.
      </p>

      <p>
        Behalve indien het statuut afloopt overeenkomstig paragraaf 3bis of beëindigd wordt overeenkomstig het eerste lid of op schriftelijk
        verzoek van het gezin blijft het gezin het statuut van beschermde afnemer behouden zolang het voldoet aan de voorwaarden vastgelegd
        in paragraaf 1, 2 of 3 en het zijn afbetalingsplan naleeft.
      </p>

      <p> De noodleverancier vraag om de twee jaar :</p>

      <p>
        1° dat het gezin binnen de negentig dagen na zijn schriftelijk verzoek het bewijs levert dat het voldoet aan de voorwaarden
        vastgelegd in paragraaf 1, 2 of 3. De noodleverancier brengt het O.C.M.W. hiervan op de hoogte. Na deze termijn wordt de schorsing
        beëindigd en wordt het contract tussen de leverancier en het gezin volledig hervat. De noodleverancier brengt het O.C.M.W. hiervan
        op de hoogte ;
      </p>

      <p>
        2° aan de leverancier te bevestigen dat het gezin zich aan zijn afbetalingsplan houdt. Als het gezin zijn afbetalingsplan niet
        naleeft, wordt de schorsing beëindigd en wordt het contract tussen de leverancier en het gezin volledig hervat. De noodleverancier
        brengt het O.C.M.W. hiervan op de hoogte.
      </p>

      <p>
        Art. 25octies. § 1. - Als het afbetalingsplan niet wordt nageleefd en indien de afnemer niet als beschermde afnemer werd erkend, kan
        de leverancier aan de vrederechter de ontbinding van het contract verbonden met het gezin en de toestemming tot afsluiting door de
        netbeheerder vragen na het bewijs te hebben geleverd van de naleving van de procedure voorzien in de artikelen 25ter tot 25septies
        en na handhaving van de levering gedurende een periode van minimum zestig dagen op onafgebroken wijze, vanaf de datum dat de
        ingebrekestelling naar het gezin werd verstuurd.
      </p>

      <p>
        § 2. - Het verzoek tot ontbinding van het contract en de toestemming tot afsluiting kan worden ingeleid op tegensprekelijk
        verzoekschrift, overeenkomstig artikel 1034bis van het Gerechtelijk Wetboek.
      </p>

      <p>
        De akte van rechtsingang bevat de vermelding die bepaalt dat het gezin, teneinde het bedrag dat voor zijn verbruik wordt opgeëist te
        verifiëren, een afrekening van de verschuldigde sommen en een opname van zijn meter kan laten uitvoeren op kosten van de
        leverancier, bij gebrek aan een opgenomen meterstand of wanneer de meterstand niet werd meegedeeld door de afnemer en gevalideerd
        door de distributienetbeheerder, in de laatste drie maanden.
      </p>

      <p>De distributienetbeheerder voert de opname uit binnen de vijftien dagen vanaf het in vorig lid bedoelde verzoek van het gezin.</p>

      <p>
        § 3. - De vraag aan de vrederechter wordt door de leverancier aan het O.C.M.W. van de gemeente van de woonplaats van de afnemer
        meegedeeld, evenals het bewijs van de naleving van de procedure, tenzij het gezin vroeger de mededeling van zijn naam heeft
        geweigerd overeenkomstig artikel 25sexies, § 1, teneinde het voor het O.C.M.W. mogelijk te maken om in te grijpen.
      </p>

      <p>
        § 4. - Ieder vonnis dat de ontbinding van het contract uitspreekt geeft van rechtswege de toelating tot afsluiting door de betrokken
        distributienetbeheerder, met inbegrip van de toegang tot de meter met bijstand van de openbare macht indien noodzakelijk.
      </p>

      <p>
        § 5. Voor het geval dat het gezin op het adres van het verbruik is gedomicilieerd, kan de leverancier slechts laten overgaan tot de
        afsluiting één maand na enerzijds de betekening aan het gezin van het vonnis van ontbinding en anderzijds de mededeling via
        schriftelijke of elektronische weg van zijn beslissing om over te gaan tot deze afsluiting in uitvoering van dit vonnis aan het
        O.C.M.W. van de gemeente waar zijn afnemer gedomicilieerd is, tenzij het gezin voordien de mededeling van zijn naam in toepassing
        van artikel 25sexies, § 1, geweigerd zou hebben.
      </p>

      <p>
        § 6. - Zonder afbreuk te doen aan artikel 25sexies, § 4 kan de afsluiting van een gezin niet plaatsvinden in de winterperiode, de
        periode tijdens dewelke de levering aan het gezin door de noodleverancier wordt gewaarborgd. Indien de noodleverancier het gezin
        voorziet van elektriciteit en gas, is artikel 25undecies, tweede lid van toepassing. Dat verbod op het afsluiten van een gezin heeft
        betrekking op de afsluitingsaanvragen na machtiging door de vrederechter en de aanvragen voor de afsluiting van een afnamepunt
        waarvoor het contract afloopt tijdens de winterperiode. Dit verbod tot afsluiting heeft geen betrekking op afsluitingen om
        veiligheidsredenen. Wanneer de reden voor de aanvraag tot afsluiting van een afnamepunt het aflopen van het contract tijdens de
        winterperiode is, wordt de afsluitingsaanvraag uitgevoerd aan het einde van de winterperiode, tenzij het gezin over een nieuw
        leveringscontract voor het desbetreffende afnamepunt beschikt.
      </p>

      <p> ...</p>

      <p>
        De Regering kan na advies van Brugel de aanvullende regels en voorwaarden vaststellen met betrekking tot de leveringen in de winter
        van deze paragraaf. Zij kan uitzonderlijk de winterperiode verlengen tot na 31 maart indien het klimaat dat vereist of in geval van
        overmacht.
      </p>

      <p>
        § 7. - De leverancier en de noodleverancier delen onderling en elk semester de staat van de naleving van het afbetalingsplan mee.
      </p>

      <p>
        § 8. - Indien de beschermde afnemer echter schulden ten opzichte van de noodleverancier heeft gevestigd, kan deze zijn vorderingen
        door wettelijke middelen terugvorderen.
      </p>

      <p>
        Als de beschermde afnemer zijn afbetalingsplan ten aanzien van zijn leverancier niet naleeft maar deze zijn leveringen aan de
        noodleverancier wel betaalt, herinnert de noodleverancier het gezin aan de noodzaak zijn afbetalingsplan na te leven teneinde zijn
        statuut van beschermde afnemer te behouden en brengt hij het O.C.M.W. op de hoogte.
      </p>

      <p>
        Als de beschermde afnemer in gebreke blijft van betaling van de noodleverancier, nadat deze hem in gebreke gesteld heeft, deelt deze
        leverancier aan het O.C.M.W. van de gemeente van het leveringspunt de naam en het adres van de beschermde afnemer mee. Als uiterlijk
        zestig dagen na de mededeling van de naam van de beschermde afnemer aan het O.C.M.W., deze laatstgenoemde niet aan de
        noodleverancier heeft laten weten dat deze afnemer bijstand van het O.C.M.W. geniet of niet aan de noodleverancier een voorstel van
        afbetalingsplan voor alle schulden ten aanzien van de noodleverancier, medeondertekend voor akkoord door de afnemer, heeft
        overgemaakt, kan de noodleverancier aan de vrederechter de ontbinding van het noodleveringscontract vragen, met bewijs van naleving
        van de voorziene procedure. Evenzo, kan de noodleverancier de ontbinding van het noodleveringscontract vragen in geval van
        niet-naleving van het hierboven aangehaalde afbetalingsplan. De ontbinding van het noodleveringscontract heeft van rechtswege de
        ontbinding van het contract met de oorspronkelijke leverancier tot gevolg. De Regering kan de modaliteiten voor deze procedures
        vastleggen.
      </p>

      <p>
        § 9. Indien een gezin niet beleverd wordt of schulden heeft bij minstens twee leveranciers, kan het O.C.M.W. na een maatschappelijk
        onderzoek de noodleverancier een gewaarborgde levering ten laste van het gezin opleggen gedurende twaalf maanden.
      </p>

      <p>
        De noodleverancier kan de gewaarborgde levering weigeren als het gezin een schuld van minstens 300 euro heeft bij de noodleverancier
        en er voor deze schuld geen redelijk afbetalingsplan is overeengekomen.
      </p>

      <p>
        De gewaarborgde levering loopt af na een periode van twaalf maanden, te rekenen vanaf de eerste dag van de gewaarborgde levering
        door de noodleverancier, tenzij deze vooraf op verzoek van het gezin is beëindigd of het gezin een leveringscontract heeft gesloten
        voor het betreffende afnamepunt.
      </p>

      <p>
        Het O.C.M.W. kan de gewaarborgde levering na een maatschappelijk onderzoek verlengen voor een nieuwe periode van twaalf maanden.
      </p>

      <p>
        Na afloop van deze periode van twaalf maanden en bij gebrek aan een leveringscontract voor het betreffende afnamepunt of van een
        verlenging van het recht op gewaarborgde levering, sluit de distributienetbeheerder het betreffende afnamepunt af. De afsluiting van
        een gezin op grond van deze paragraaf kan, overeenkomstig paragraaf 6, niet plaatsvinden tijdens de winterperiode.
      </p>

      <p>
        De noodleverancier stuurt het gezin dat een gewaarborgde levering geniet uiterlijk vier maanden voor het verstrijken van de periode
        van twaalf maanden een brief om :
      </p>

      <p> 1° het te herinneren aan de vervaldatum van zijn recht op gewaarborgde levering ;</p>

      <p>
        2° het uit te nodigen om een leveringscontract te sluiten dat uiterlijk bij het verstrijken van zijn recht op gewaarborgde levering
        in werking treedt ;
      </p>

      <p>
        3° het te herinneren aan de mogelijkheid om zijn recht op gewaarborgde levering te verlengen en het te verzoeken om contact op te
        nemen met het O.C.M.W. van zijn woonplaats indien het een dergelijke verlenging wenst aan te vragen ;
      </p>

      <p>
        4° het eraan te herinneren dat bij het verstrijken van zijn recht op gewaarborgde levering het afnamepunt in kwestie zal worden
        afgesloten als er geen leveringscontract is afgesloten of het recht op gewaarborgde levering niet werd verlengd.
      </p>

      <p> Deze kennisgeving gebeurt per aangetekende brief.</p>

      <p>
        Indien het gezin dat een gewaarborgde levering geniet echter schulden ten opzichte van de noodleverancier heeft gevestigd, kan deze
        zijn schuldvorderingen met alle rechtsmiddelen terugvorderen.
      </p>

      <p>
        Een kwalitatieve en kwantitatieve evaluatie van de uitvoering van deze paragraaf wordt uiterlijk in januari 2025 door de Regering,
        op voorstel van de minister, aan het Brussels Hoofdstedelijk Parlement meegedeeld. Deze beoordeling omvat minstens de volgende
        elementen : het aantal gezinnen dat een gewaarborgde levering geniet en de kosten die de uitvoering van deze paragraaf meebrengt.
      </p>

      <p> Art. 25novies</p>

      <p>
        Om aan de afnemers begrijpelijke en onderling vergelijkbare voorstellen te doen, vermeldt de leverancier, ongeacht zijn prijzen en
        tarieven, in zijn voorstel, duidelijk en afzonderlijk, de eenheidsprijs en de gemiddelde prijs van elke gefactureerde kWh volgens de
        verkochte hoeveelheden en per tariefcategorie, de periodieke forfaits, de retributies, indexatieformules, de belastingen, de
        abonnementen en de prijzen van eventuele andere diensten.
      </p>

      <p>
        Op voorstel van Brugel, stelt de Regering de minimumnormen vast waaraan de documenten van voorstellen van contract en de
        facturatiedocumenten moeten voldoen.
      </p>

      <p> Art. 25decies</p>

      <p>
        In geval van verhuizing binnen het grondgebied van het Brussels Hoofdstedelijk Gewest ..., zal de leverancier ervoor zorgen, voor
        zover dit technisch mogelijk is, dat de gezinnen kunnen genieten van hetzij, hetzelfde contract, hetzij dezelfde contractuele
        voorwaarden en tariefvoorwaarden als die waarvan zij tot dusver genoten, en dit tot het verstrijken van het lopende contract.
      </p>

      <p>
        In geval van verhuis en bij afwezigheid van afsluiting van de meter wordt een tegensprekelijk opname van de meterstand uitgevoerd
        door de oude en de nieuwe bewoner of door de oude bewoner en de eigenaar van het goed dat beleverd wordt. Hiertoe wordt een
        verhuisformulier opgesteld en door Brugel aangeboden op haar website. Bij ontstentenis van een tegensprekelijke opname die wordt
        overgemaakt aan de distributienetbeheerder , per aangetekende brief of elektronisch, of van opname die aan deze werd gevraagd door
        een leverancier, heeft houdt de netbeheerder rekening met de stand die bezorgd wordt door de oude of de nieuwe bewoner aan de hand
        van een foto van de meter genomen op de dag van zijn vertrek of op de dag dat hij op de plaats aankomt, de schatting van de
        effectieve stand die werd uitgevoerd door de distributienetbeheerder bewijskracht tot het tegendeel bewezen is.
      </p>

      <p></p>

      <p>Art. 25undecies</p>

      <p>
        Het systeem inzake bescherming van artikelen 25sexies tot en met 25octies evenals de contactgegevens van het Informatiecentrum voor
        gas- en elektriciteitsconsumenten van artikel 33bis worden vermeld op iedere factuur, herinnering tot betaling of ingebrekestelling
        van een factuur .... Deze documenten omvatten ook een exacte en gedetailleerde afrekening van alle van de verbruiker geëiste
        bedragen, volgens een door Brugel vastgelegd model, inclusief de forfaitaire bedragen geëist bij wijze van kosten voor de
        herinnering en de ingebrekestelling, in uitvoering van artikel 25sexies, § 2.
      </p>

      <p>
        De elektriciteitsfacturatie mag niet worden verward met de gasfacturatie. Nochtans mag de elektriciteits- en gasleverancier één
        enkele factuur verzenden voor de twee soorten energie, waarbij in detail het verbruik wordt vermeld in monetaire eenheden en in
        energetische eenheden van de twee soorten geleverde energie.
      </p>

      <p> De Regering kan de regels hiervoor bepalen.</p>

      <p></p>

      <p> Art. 25duodecies</p>

      <p>
        Zonder dat zij op geen enkele wijze mogen discrimineren en met name discriminatie inzake kost, investering en tijd, zien de
        leveranciers en de tussenpersonen erop toe dat :
      </p>

      <p>
        1° wanneer hun eindafnemers individueel of collectief van leverancier wensen te veranderen, met inachtneming van de contractuele
        voorwaarden, deze wissel gebeurt binnen een termijn van maximaal drie weken te rekenen vanaf de datum van de vraag van de
        eindafnemer. Uiterlijk op 1 januari 2026 moet de technische procedure voor het veranderen van leverancier voor elke eindafnemer met
        een slimme meter binnen 24 uur worden uitgevoerd op elke werkdag ;
      </p>

      <p>
        2° aan hun eindafnemers alle relevante gegevens verstrekt worden betreffende hun verbruik, evenals het geheel van de persoonlijke
        gegevens in hun dossiers.
      </p>

      <p>
        Bovendien, zien de leveranciers en de tussenpersonen erop toe dat een hoog beschermingsniveau aan hun afnemers wordt verzekerd, met
        name wat de transparantie van de contractuele voorwaarden, de algemene informatie en de mechanismen voor de beslechting van
        geschillen betreft.
      </p>

      <p> ...</p>

      <p></p>

      <p> Art. 25tredecies</p>

      <p>
        De sociale bescherming voorzien door de federale wetgeving inzake tarieven voor beschermde afnemers wordt uitgebreid tot de afnemers
        die worden bevoorraad door de noodleverancier krachtens deze ordonnantie.
      </p>

      <p></p>

      <p> Art. 25quattuordecies</p>

      <p>
        § 1. Onder voorbehoud van een federale norm die gunstiger is voor de verbruiker, met name in de wet van 6 april 2010 betreffende
        marktpraktijken en consumentenbescherming, en het kaderakkoord van 16 september 2004, bijgewerkt op 11 juni 2008, betreffende de
        consument in de geliberaliseerde gas- en elektriciteitsmarkt, hebben de nadere regels inzake de voorlichting van de eindgebruikers
        door de leveranciers tot doel dat de afnemers :
      </p>

      <p> 1° recht hebben op een contract met hun elektriciteitsleverancier waarin zijn opgenomen :</p>

      <p> a) de identiteit en het adres van de leverancier;</p>

      <p>b) de geleverde diensten, de aangeboden kwaliteitsniveaus van de diensten en de benodigde tijd voor de eerste aansluiting;</p>

      <p> c) de aangeboden soorten onderhoudsdiensten;</p>

      <p>
        d) de wijze waarop de meest recente informatie over alle geldende tarieven , gebundelde producten of diensten en onderhoudskosten
        kan worden verkregen;
      </p>

      <p>
        e) de duur van het contract, de voorwaarden voor verlenging en beëindiging van het contract en onderbreking van de diensten, met
        inbegrip van producten of diensten die met deze diensten gebundeld zijn en of kosteloze opzegging van het contract toegestaan is ;
      </p>

      <p>
        f) alle vergoedingen en terugbetalingsregelingen die gelden indien de contractuele kwaliteitsniveaus van de diensten niet worden
        gehaald, met inbegrip van onnauwkeurige of te late facturering;
      </p>

      <p>g) de methode voor het beginnen van buitengerechtelijke procedures voor de beslechting van geschillen;</p>

      <p>
        h) informatie over consumentenrechten, met inbegrip van klachtenbehandeling en de in dit punt bedoelde informatie, de
        contactgegevens (met name het internetadres) van onafhankelijke adviesinstellingen voor de consumenten, van energie-agentschappen of
        van gelijkaardige instellingen bij wie ze advies kunnen inwinnen over de bestaande maatregelen inzake energie-efficiëntie, de
        referentieprofielen die met hun energieverbruik overeenstemmen en de technische specificaties van energieapparaten die het verbruik
        kunnen verminderen, welke duidelijk wordt meegedeeld door middel van de facturen of via de websites van het elektriciteitsbedrijf.
      </p>

      <p>
        De contractuele voorwaarden zijn eerlijk en vooraf bekend. In ieder geval wordt deze informatie voorafgaand aan de ondertekening of
        bevestiging van het contract verstrekt. Indien contracten door middel van tussenpersonen worden gesloten, wordt bovengenoemde
        informatie eveneens voorafgaand aan de ondertekening van het contract verstrekt;
      </p>

      <p>De eindafnemers krijgen een goed zichtbare, beknopte en duidelijke samenvatting van de voornaamste contractuele voorwaarden ;</p>

      <p>
        2° tijdig in kennis worden gesteld van ieder voornemen de contractuele voorwaarden te wijzigen en op de hoogte worden gesteld van
        hun recht het contract op te zeggen wanneer zij van een dergelijk voornemen in kennis worden gesteld. De leveranciers brengen hun
        eindafnemers op een transparante en begrijpelijke manier op de hoogte van aanpassingen van de leveringsprijs en van de redenen, de
        voorafgaande omstandigheden en de reikwijdte van deze aanpassingen, en doen dit tijdig en ten laatste twee weken voor de aanpassing
        van kracht wordt of, voor huishoudelijke afnemers, ten laatste een maand voor de aanpassing van kracht wordt. Het staat de
        eindafnemers vrij om een contract op te zeggen indien zij de hun door de elektriciteitsleverancier meegedeelde nieuwe contractuele
        voorwaarden of aanpassingen van de leveringsprijs niet aanvaarden ;
      </p>

      <p>
        3° transparante informatie ontvangen over de geldende prijzen en tarieven, waaronder de sociale tarieven, en over de algemene
        voorwaarden met betrekking tot de toegang tot en het gebruik van elektriciteitsdiensten , op verzoek van de afnemers worden hen
        tijdig informatie en schattingen met betrekking tot de energiekosten verstrekt in een bevattelijke vorm die hen toelaat aanbiedingen
        op basis van gelijke criteria te vergelijken ;
      </p>

      <p>
        4° een ruime keuze van betalingswijzen wordt aangeboden, die geen enkele categorie eindafnemers ongegrond discrimineert. Systemen
        voor vooruitbetaling zijn billijk en vormen een goede afspiegeling van het vermoedelijke maandelijkse verbruik. Ieder verschil in de
        tarifering van betalingswijzen of systemen voor vooruitbetaling is objectief, niet-discriminerend en evenredig en mag niet meer
        bedragen dan de rechtstreekse kosten die de begunstigde maakt voor het gebruik van een specifieke betalingswijze of een specifiek
        systeem voor voorafbetaling. Huishoudelijke afnemers die gebruik maken van systemen voor vooruitbetaling, worden niet benadeeld door
        deze systemen voor vooruitbetaling ;
      </p>

      <p> 5° geen kosten in rekening worden gebracht indien zij van leverancier veranderen;</p>

      <p> ...</p>

      <p>
        6° naar behoren worden geïnformeerd, door middel van de factuur of op enige andere wijze , met name via elektronische weg, over hun
        daadwerkelijk elektriciteitsverbruik en de kosten daarvan, zulks voldoende frequent, minstens eenmaal in een periode van 12 maanden,
        om hen in staat te stellen hun eigen elektriciteitsverbruik te regelen en als de eindafnemer uitgerust is met een slimme meter,
        minstens 1 keer per maand. Voor de verstrekking van de informatie wordt een voldoende ruime termijn ingesteld, waarbij rekening
        wordt gehouden met de capaciteit van de meetapparatuur van de afnemer, met het elektriciteitsproduct in kwestie en met de
        kostenefficiëntie van deze maatregelen. Voor deze dienst mogen de verbruiker geen extra kosten worden aangerekend, het omvat niet
        het recht om een gratis aanpassing van de meterinrichting of van de periodiciteit van de meteropname te eisen. De leverancier
        informeert de afnemer proactief over zijn recht om, één keer per trimester een meteropname aan zijn leverancier mee te delen met het
        oog op het kosteloos verkrijgen van precieze informatie over de facturatie en de actuele energiekost. De eindafnemer kan zijn
        meterstand ofwel rechtstreeks opnemen, ofwel onrechtstreeks via een hiervoor geschikte interface. Slechts een opname die gevalideerd
        werd door de distributienetbeheerder is geldig voor iedere facturatie, zelfs als de eindafnemer uitgerust is met ... een slimme
        meter. De informatie over het werkelijke elektriciteitsverbruik omvat een vergelijking van het huidige elektriciteitsverbruik van de
        eindafnemer met zijn verbruik in dezelfde periode van het voorgaande jaar, in grafische vorm, evenals een vergelijking met het
        gemiddelde en mediaanverbruik van een eindafnemer die tot dezelfde gebruikerscategorie behoort en de norm of referentie vormt. De
        Regering kan aanvullende modaliteiten met betrekking tot de periodiciteit en de inhoud van de informatie en facturatie vastleggen;
      </p>

      <p>
        7° na iedere verandering van elektriciteitsleverancier ten laatste maximaal zes weken nadat deze leverancier hiervan in kennis is
        gesteld een definitieve afsluitingsrekening ontvangen. De nadere regels met betrekking tot de informatie van de eindafnemers door de
        distributienetbeheerders, de gewestelijke transmissienetbeheerders en de leveranciers, en in het bijzonder betreffende de incidenten
        en stopzettingen van levering, evenals de nadere regels betreffende het klachtenbeheer, worden vastgelegd door Brugel;
      </p>

      <p>
        8° eerlijke en transparante algemene voorwaarden krijgen, die opgesteld zijn in duidelijke en begrijpelijke taal en die geen
        niet-contractuele belemmeringen bevatten voor het uitoefenen van de rechten van eindafnemers, zoals overdreven contractuele
        documentatie. Eindafnemers worden beschermd tegen oneerlijke of misleidende verkoopmethoden.
      </p>

      <p>
        § 2. Onverminderd § 1, behalve indien kan worden aangetoond dat het om een noodsituatie of een situatie met verschillende incidenten
        gaat, informeren de distributienetbeheerders en de gewestelijke transmissienetbeheerders de gebruikers van het midden- en
        hoogspanningsnet, evenals hun evenwichtsverantwoordelijke, minimum tien werkdagen van tevoren over het begin en de vermoedelijke
        duur van de onderbreking. Deze termijn wordt herleid tot vijf werkdagen indien het gaat om de regularisering van een voorlopige
        herstelling. De evenwichtsverantwoordelijke informeert de leverancier in voorkomend geval.
      </p>

      <p>
        § 3. Naast de onder § 2 voorziene informatie maken de transmissienetbeheerder, de distributienetbeheerder en de gewestelijke
        transmissienetbeheerder binnen de 24 uur de lijst, de duur en de oorzaken bekend op hun website van de geplande of incidentele
        onderbrekingen die hebben plaatsgevonden op het midden- en hoogspanningsnet. Deze informatie wordt eveneens meegedeeld aan Brugel.
      </p>

      <p>
        § 4. De leveranciers en de netbeheerders stellen een efficiënte klachtenbehandelingdienst ter beschikking van hun respectieve
        afnemers waarbij de afnemers genieten van transparante, eenvoudige en gratis procedures. Deze dienst bevestigt de ontvangst van
        iedere klacht binnen een termijn van vijf werkdagen en verstrekt een met redenen omkleed antwoord binnen twintig werkdagen vanaf de
        datum van ontvangstbevestiging.
      </p>

      <p>
        Deze procedure van buitengerechtelijke geschillenbeslechting laat een billijke en snelle regeling van de geschillen toe binnen een
        termijn van twee maanden, die wordt aangevuld met, waar dat gerechtvaardigd is, een systeem van terugbetaling en/of vergoeding.
        Brugel bepaalt de straffen die in geval van niet-naleving van deze verplichting worden opgelopen en kan de modaliteiten bepalen die
        met betrekking tot de doeltreffendheid van de dienst worden verwacht.
      </p>

      <p> § 5. ...</p>

      <p> Art. 25quindecies</p>

      <p>
        Ten aanzien van de professionele afnemers die minder dan 5 personen in dienst hebben en die aan het distributie- of lokale
        transmissienet verbonden zijn, is de leverancier verplicht om een herinneringsbrief en een aanmaningsbrief te versturen en om daarna
        een aanzuiveringplan te onderhandelen voordat hij zijn leveringscontract kan verbreken.
      </p>

      <p></p>

      <p>
        Art. 25sexiesdecies. § 1. De Regering kan de leveranciers, bij wijze van openbaredienstverplichting, verplichten de doelstellingen
        en de prestatie-indicatoren met betrekking tot hun prestaties na te leven, in functie van het aantal door hen beleverde afnemers, op
        basis van een voorstel dat door Brugel wordt geformuleerd na overleg met de leveranciers. Brugel controleert of deze doelstellingen
        worden nagekomen en publiceert elk jaar op zijn website de respectievelijke prestaties van elke leverancier ten opzichte van deze
        doelstellingen.
      </p>

      <p>
        § 2. De Regering kan andere modaliteiten van verplichtingen van openbare dienst bepalen voor wat betreft de regelmatigheid, de
        kwaliteit en de facturatie van de leveringen.
      </p>

      <p></p>

      <p> Art. 25septiesdecies. (…)</p>

      <p> Art. 25octiesdecies</p>

      <p>
        De opdrachten toevertrouwd aan de O.C.M.W.&apos;s door en krachtens deze ordonnantie moeten worden opgevat en worden uitgevoerd
        onverminderd artikel 109 van de organieke wet van 8 juli 1976 betreffende de openbare centra voor maatschappelijk welzijn en met
        uitsluiting van elke vorm van administratief toezicht op de beslissingen inzake toekenning van individuele hulp en terugvordering..
      </p>

      <p> Art. 25noviesdecies.</p>

      <p>
        In geval van faillissement of van intrekking van de leveringsvergunning van een leverancier, zal de levering van de eindafnemers
        door de standaardleverancier worden verzekerd aan de voorwaarden van de standaardlevering voor een maximale duur van een jaar.
      </p>

      <p></p>

      <h3>AARDGAS: HOOFDSTUK Vbis. Verplichtingen van openbare dienst betreffende de levering van gas.</h3>

      <p></p>

      <p>
        Art. 20bis § 1. De leverancier maakt, aan elke afnemer die erom verzoekt, binnen tien werkdagen een redelijk en niet-discriminerend
        voorstel van leveringscontract over en deelt hem de algemene leveringsvoorwaarden mee evenals, met name wanneer de afnemer een
        huishoudelijke afnemer is, de bepalingen van deze ordonnantie die betrekking hebben op de beschermde afnemers. Deze verplichting
        berust op de leverancier voor alle soorten meetregimes.
      </p>

      <p>
        Indien de vraag uitgaat van een afnemer of een voormalige afnemer die zijn schulden bij de betrokken leverancier niet volledig heeft
        gezuiverd en die het eventueel opgesteld afbetalingsplan niet heeft nageleefd, kan de leverancier ofwel schriftelijk weigeren om een
        voorstel tot leveringscontract te doen ofwel schriftelijk een voorstel tot leveringscontract verzenden dat wordt gesloten nadat de
        afnemer een borg heeft gesteld.
      </p>

      <p> ...</p>

      <p>
        § 2. De leveranciers delen de algemene voorwaarden, alsook elke wijziging daarvan inzake de leveringscontracten mee aan Brugel,
        zodat de regulator hun conformiteit met de Brusselse wetgeving kan controleren.
      </p>

      <p>
        Indien de in het vorige lid opgesomde documenten niet worden bezorgd, worden sancties voorzien. De Regering legt de modaliteiten
        daarvan vast.
      </p>

      <p> </p>

      <p> Art. 20ter</p>

      <p>
        De leveranciers waarborgen de gezinnen een ononderbroken levering van gas voor het verbruik van het gezin tegen niet-discriminerende
        voorwaarden.
      </p>

      <p>
        Wordt beschouwd als discriminerend; elk verschil in behandeling dat niet redelijk verantwoord kan worden en dat met name steunt op
        het statuut, het inkomstenniveau of de woonplaats.
      </p>

      <p>
        Deze bevoorrading is niet voorzien voor de gemeenschappelijke ruimtes van woongebouwen, noch voor tweede woningen, noch voor
        woningen die onbewoond zijn volgens een vaststelling van de gemeentepolitie.
      </p>

      <p>
        Voor gemeenschappelijk gebouw met gemeenschappelijke verwarmingsketel stelt de Regering de nadere regels van de verplichting
        betreffende deze ononderbroken gasbevoorrading vast.
      </p>

      <p>
        Onder voorbehoud van de in dit hoofdstuk vastgelegde ontbindingstermijnen, worden de leveringscontracten gesloten voor een vaste
        periode van minimum drie jaar. Een gezin kan ze evenwel altijd opzeggen mits een opzeggingstermijn van drie weken.
      </p>

      <p></p>

      <p></p>

      <p> Art. 20quater</p>

      <p>
        § 1. De niet-betaling van het gefactureerde bedrag voor het gasverbruik maakt het voorwerp van een herinnering door de leverancier
        uit binnen 15 dagen na de vervaldatum van de factuur. In geval van niet-betaling van het gefactureerde bedrag, stuurt de leverancier
        een ingebrekestelling per aangetekende brief en per gewone brief ten vroegste 15 dagen en ten laatste 30 dagen na de verzending van
        de herinnering. Bij ontstentenis van betaling binnen zeven dagen vanaf de ontvangst van de ingebrekestelling, stelt de leverancier
        een redelijk afbetalingsplan aan het gezin voor en stelt de netbeheerder in kennis van zijn voornemen om de procedure tot
        beëindiging van het leveringscontract op te starten. De leverancier licht eveneens het gezin in over zijn voornemen om het O.C.M.W.
        van de gemeente waar het leveringspunt zich bevindt in te lichten , met name om hem toe te laten de bijstand ervan te genieten bij
        het onderhandelen over zijn afbetalingsplan, evenals over zijn recht om de mededeling van zijn naam aan het O.C.M.W. te weigeren,
        door aangetekende brief, gericht aan de leverancier, binnen de tien dagen. Deze mededeling gebeurt in de vorm van een listing met de
        contactgegevens van de betrokken afnemers van de leverancier, opgesteld overeenkomstig het door Brugel vastgelegde model en met de
        door hem vastgelegde frequentie.
      </p>

      <p>
        De leverancier deelt het gezin zijn voorstel van afbetalingsplan schriftelijk mee, indien het gezin hem daarom verzoekt; hij deelt
        het gezin het tussen hen overeengekomen afbetalingsplan ambtshalve schriftelijk mee. Het gezin, of het O.C.M.W. op verzoek van het
        gezin, kan ook een afbetalingsplan voorstellen aan de leverancier.
      </p>

      <p>
        Het redelijk karakter van het afbetalingsplan, met name de duur en het bedrag van de gespreide betalingen, wordt beoordeeld in
        functie van het evenwicht dat het tot stand doet komen tussen het belang van de leverancier om zijn schuld terugbetaald te krijgen
        binnen een redelijke termijn en het belang van de afnemer om zijn schuld te vereffenen binnen een termijn die aangepast is aan zijn
        financiële toestand. Een afbetalingsplan is niet redelijk als het de afnemer en zijn gezin niet in de mogelijkheid stelt een
        menswaardig bestaan te leiden. Indien het gezin wordt bijgestaan door een erkend centrum voor schuldbemiddeling of door het
        O.C.M.W., dan zal deze instantie opnieuw onderhandelen over het afbetalingsplan indien ze vaststelt dat het niet of niet langer
        redelijk is. De minimuminformatie die elk afbetalingsplan moet vermelden, wordt gespecificeerd in bijlage 2.
      </p>

      <p> Bij overdracht van schuldvordering door de leverancier :</p>

      <p>
        1° de overdracht is slechts tegenwerpelijk aan de overgedragen schuldenaar vanaf het ogenblik dat de overgedragen schuldenaar
        hiervan per aangetekende brief in kennis werd gesteld of door hem werd erkend. Ingeval een gerechtelijke procedure wordt ingeleid,
        moet de kennisgeving gebeuren twee maanden voordat de overnemer een gerechtelijke procedure tegen hem kan instellen;
      </p>

      <p>
        2° de overnemer blijft gebonden aan dezelfde verplichtingen als de overdrager met inbegrip van die opgelegd in deze ordonnantie en
        in de artikelen 591, 215° en 628, 25° van het Gerechtelijk Wetboek;
      </p>

      <p>3° de overnemer blijft gebonden aan zijn informatieplicht, zowel ten overstaan van de overdrager als van de eindafnemer.</p>

      <p>
        Overeenkomstig artikel 5 van de wet van 20 december 2002 betreffende de minnelijke invordering van schulden van de consument is het
        verboden aan de consument enige vergoeding te vragen, anders dan de overeengekomen bedragen in de onderliggende overeenkomst in
        geval van niet-naleving van de contractuele verbintenissen.
      </p>

      <p>Voor zover zij contractueel bepaald zijn, kan geen enkel ander bedrag dan de hierna vermelde aan de consument worden gevraagd :</p>

      <p>
        1° alle invorderingskosten voor onbetaalde facturen, mogen 7,50 euro voor een herinnering en 15 euro voor ingebrekestelling niet
        overschrijden, met dien verstande dat het totaal van de invorderings- en administratieve kosten de som van 55 euro per
        leveringscontract niet mag overschrijden. De Regering kan deze forfaitaire sommen aanpassen rekening houdend met het indexcijfer van
        de consumptieprijzen. Voor de toepassing van dit punt :
      </p>

      <p>
        a) het maximum van 55 euro is van toepassing tijdens de minnelijke invorderingsprocedure, vanaf het moment dat de eerste aanmaning
        tot betaling wordt verzonden, en eindigt wanneer de schuld volledig is betaald of wanneer de zaak wordt doorverwezen naar de
        vrederechter ;
      </p>

      <p>
        b) onder &quot; totale invorderings- en administratiekosten &quot; wordt verstaan : de aanmanings- en ingebrekestellingskosten, de
        contractuele verwijlinteresten, de boeteclausule of de kosten van een derde die een activiteit van minnelijke invordering van
        schulden uitoefen ;
      </p>

      <p> 2° het verschuldigde resterende saldo;</p>

      <p> 3° ...</p>

      <p>Zodra de ontbindingsprocedure wordt ingeleid, zal geen andere herinnerings- of ingebrekestellingskost mogen worden geëist.</p>

      <p>
        § 1bis. Van zodra de leverancier hem in kennis heeft gesteld van zijn voornemen om de procedure tot beëindiging van het
        leveringscontract op te starten en ten laatste tien dagen na de ontvangst van deze informatie, waarschuwt de netbeheerder de
        eindafnemer voor de gevolgen van het niet-betalen van het gefactureerde bedrag. Hij informeert hem ook over het bestaan van het
        beschermingssysteem van artikelen 20quater tot en met 20sexies en stuurt hem de contactgegevens van het O.C.M.W. van zijn woonplaats
        en van het informatiecentrum voor afnemers van gas en elektriciteit bedoeld in artikel 33bis van de ordonnantie van 19 juli 2001.
        Die informatie wordt verstrekt in duidelijke en begrijpelijke taal.
      </p>

      <p>
        § 2. De leverancier kan geen afsluiting van gas op een leveringspunt dat een hoofdverblijfplaats of een verblijfplaats tot
        hoofdzakelijk huishoudelijk gebruik voorziet laten doorvoeren zonder vooraf de procedure, beschreven in dit hoofdstuk, te hebben
        gevolgd en zonder de toestemming van de vrederechter.
      </p>

      <p>
        Deze bepaling is niet van toepassing wanneer de afsluiting vereist is omdat de veiligheid van goederen of personen, of de goede
        werking van het distributienetwerk ernstig in het gedrang komt. Iedere afsluiting zonder de instemming van de vrederechter op basis
        van dit artikel maakt het voorwerp uit van een informatiemaatregel via aangetekende zending, met vermelding voor de verbruiker van
        de precieze redenen die tot die afsluiting geleid hebben, alsook de duur ervan. Een kopie van de brief wordt naar Brugel gestuurd.
      </p>

      <p>
        Bovendien, als de netbeheerder door een leverancier belast wordt met het afsluiten van een afnamepunt dat niet gedekt is door een
        contract of niet standaard beleverd wordt, neemt hij de nodige maatregelen om de mogelijke aanwezigheid van een eindafnemer vast te
        stellen en nodigt hij deze uit zijn contractuele situatie binnen de veertig dagen in orde te brengen. Deze maatregelen bestaan uit
        een administratief onderzoek, gevolgd door een kort onderzoek ter plaatse als de eindafnemer zijn situatie niet in regel brengt. Bij
        gebrek aan regularisatie door de eindafnemer binnen deze termijn van veertig dagen of zodra de afwezigheid van een eindafnemer is
        bevestigd, is de toestemming van de vrederechter voor de afsluiting niet langer vereist. In het kader van het administratief
        onderzoek vraagt de netbeheerder de nodige gegevens voor de identificatie van de eigenaar van de plaats van verbruik aan de Algemene
        Administratie van de Patrimoniumdocumentatie op grond van artikel 36, 1°, van het koninklijk besluit van 30 juli 2018 betreffende
        het aanleggen en bijhouden van de kadastrale documentatie en tot vaststelling van de modaliteiten voor het afleveren van kadastrale
        uittreksels. De modaliteiten van het administratief onderzoek en van het onderzoek ter plaatse worden door Brugel en de
        distributienetbeheerder in onderling overleg bepaald.
      </p>

      <p>
        Wanneer de netbeheerder door een leverancier wordt belast met het afsluiten van een afnamepunt dat niet gedekt is door een contract
        of niet standaard beleverd wordt, en uit het administratief onderzoek of het in het derde lid bedoelde onderzoek ter plaatse blijkt
        dat de eindafnemer de laatste bewoner is die gekend is bij de netbeheerder, dan sluit de netbeheerder het afnamepunt niet af en
        vraagt hij de leverancier om de afsluitingsaanvraag te annuleren. De netbeheerder brengt Brugel hiervan op de hoogte.
      </p>

      <p>
        § 3. Tenzij het gezin vroeger de mededeling van zijn naam heeft geweigerd overeenkomstig § 1, kan het O.C.M.W. dan een
        maatschappelijk onderzoek laten uitvoeren bij het gezin in kwestie en maatregelen van hulp aan het gezin voorstellen, eventueel met
        bijstand van een schuldbemiddelingsdienst.
      </p>

      <p>
        § 4. Als de afnemer weigert dat zijn naam aan het O.C.M.W. wordt meegedeeld, als er geen enkel aanzuiveringsplan is opgesteld met of
        zonder de begeleiding van het O.C.M.W. of als het afbetalingsplan niet wordt nageleefd, kan de leverancier een brief zenden naar het
        gezin waarin het ervan op de hoogte wordt gebracht dat, indien het gezin uiterlijk binnen 15 kalenderdagen het afbetalingsplan niet
        opnieuw naleeft of indien het gezin niet het bewijs aanbrengt dat hij een &quot; beschermde afnemer &quot; is, hij aan de
        vrederechter de toestemming zal vragen om het contract te verbreken en over te gaan tot de afsluiting van het gas.
      </p>

      <p> § 5. ...</p>

      <p>
        Art. 20quinquies. § 1. Vanaf de ingebrekestelling, wordt het gezin dat het vraagt erkend als beschermd afnemer indien het één of
        meerdere van de volgende voorwaarden vervult :
      </p>

      <p> 1° het geniet het specifiek sociaal tarief;</p>

      <p>
        2° het maakt gebruik van een procedure voor schuldbemiddeling met een erkend centrum voor schuldbemiddeling of een collectieve
        schuldenregeling;
      </p>

      <p> 3° het geniet de verhoogde tussenkomst .</p>

      <p>
        § 1bis. Het gezin bedoeld in paragraaf 1, 1°, waarvan het schuldbedrag hoger is dan 150 euro voor de gasfactuur of 250 euro voor de
        enkele factuur voor beide energieën, wordt automatisch erkend als beschermde afnemer zestig dagen na de verzending van de
        ingebrekestelling, tenzij het gezin bezwaar maakt zoals bedoeld in het tweede lid.
      </p>

      <p>
        Vanaf de ingebrekestelling stelt de leverancier het gezin in kennis van deze procedure, waarna het gezin bezwaar kan maken tegen de
        automatische toekenning van het statuut van beschermde afnemer.
      </p>

      <p>
        Vanaf de automatische toekenning van dat statuut stelt de leverancier de noodleverancier in kennis en wordt de beschermde afnemer
        door laatstgenoemde bevoorraad, voor zover het gezin nog steeds aan de in het eerste lid vastgestelde voorwaarden voldoet.
      </p>

      <p>
        De Regering kan de bovengenoemde voorwaarden en modaliteiten aanpassen en aanvullen en de categorie van begunstigden van de
        procedure voor de automatische toekenning van het statuut van beschermde afnemer uitbreiden op basis van een evaluatie van het
        aantal gezinnen dat overeenkomstig die procedure als beschermde afnemer wordt erkend.
      </p>

      <p>
        § 2. Vanaf de ingebrekestelling, op verzoek van de afnemer en na het sociale onderzoek, kan het O.C.M.W. eveneens het statuut van
        beschermde afnemer aan het gezin toekennen. Vanaf de verkrijging van dit statuut, brengt het O.C.M.W. de noodleverancier hiervan op
        de hoogte en wordt de beschermde afnemer door laatstgenoemde beleverd.
      </p>

      <p>
        § 3. Indien het gezin aan geen enkele van de in § 1 van dit artikel opgesomde voorwaarden voldoet, kan het zich vanaf de
        ingebrekestelling tot Brugel richten om dit statuut te verkrijgen. De toekenningscriteria houden rekening met de inkomsten
        overeenkomstig de leden 2 tot 5 en het aantal personen in het gezin.
      </p>

      <p>
        De samengevoegde inkomsten van alle leden van het gezin dat kandidaat is voor het in lid 1 bedoelde statuut van beschermde afnemer
        mogen, voor een gegeven belastingjaar, niet hoger zijn dan 37.600 euro. Deze inkomsten omvatten niet deze van de kinderen ten laste,
        zijnde kinderen waarvoor kinderbijslag of wezenbijslag wordt uitbetaald aan een lid van dit gezin. Deze inkomsten houden rekening
        met het kadastraal inkomen van de in België of in het buitenland gelegen onroerende goederen, al dan niet bewoond als
        hoofdverblijfplaats, verminderd met een bedrag van 745 euro.
      </p>

      <p>
        Voor de gezinnen waarvan ten minste twee leden op de datum van de indiening van de aanvraag beroepsinkomsten ontvangen in de zin van
        het Wetboek van de Inkomstenbelastingen, wordt het in lid 2 bedoelde bedrag verhoogd tot 52.600 euro.
      </p>

      <p>
        Voor elk lid van het in lid 1 bedoelde kandidaat-gezin dat door de fiscale wetgeving wordt beschouwd als persoon ten laste, worden
        de in de leden 2 en 3 bedoelde bedragen verhoogd. Deze verhoging bedraagt 3.000 euro voor de eerste persoon ten laste en 1.500 euro
        voor de volgende personen ten laste.
      </p>

      <p>
        Deze bedragen zijn gekoppeld aan de evolutie van de prijsindex overeenkomstig het mechanisme dat is vastgelegd door de wet van 2
        augustus 1971 houdende inrichting van een stelsel waarbij de wedden, lonen, pensioenen, toelagen en tegemoetkomingen ten laste van
        de openbare schatkist, sommige sociale uitkeringen, de bezoldigingsgrenzen waarmee rekening dient gehouden bij de berekening van
        sommige bijdragen van de sociale zekerheid der arbeiders, alsmede de verplichtingen op sociaal gebied opgelegd aan de zelfstandigen,
        aan het indexcijfer van de consumptieprijzen worden gekoppeld.
      </p>

      <p>
        Brugel voert jaarlijks een evaluatie uit van de aan de eindafnemers aangerekende prijzen en van de weerslag van de evolutie van die
        prijzen op het aantal gezinnen dat kandidaat is voor het in lid 1 bedoelde statuut van beschermde afnemer en op de overeenkomstig de
        leden 2, 3 en 4 vastgestelde bedragen van de inkomsten. De eerste evaluatie wordt uiterlijk op 1 januari 2023 aan de regering
        meegedeeld.
      </p>

      <p>
        Op basis van de in lid 6 bedoelde evaluatie kan de regering de in de leden 2, 3 en 4 bedoelde bedragen van de inkomsten wijzigen.
      </p>

      <p>
        De regering kan bepalen welk soort inkomen in overweging moet worden genomen en welke procedure Brugel moet volgen voor het
        verkrijgen van het statuut van beschermde afnemer. Vanaf het verkrijgen van dat statuut, brengt Brugel de noodleverancier hiervan op
        de hoogte en wordt de beschermde afnemer door laatstgenoemde beleverd.
      </p>

      <p>
        § 3bis. Het gezin wordt erkend als een beschermde afnemer voor een bepaalde duur van maximaal vijf jaar, onder voorbehoud van de
        toepassing van paragraaf 6. Indien een gezin dat als beschermde afnemer is erkend, betrokken raakt bij een schuldbemiddelingsproces
        met een erkend bemiddelingscentrum of een collectieve schuldenrekening, wordt het voor onbepaalde tijd erkend als beschermde
        afnemer, onder voorbehoud van de toepassing van paragraaf 6.
      </p>

      <p>
        § 4. Zodra het gezin het statuut van beschermde afnemer heeft, wordt het contract dat met de leverancier werd gesloten opgeschort en
        kan de leverancier de vrederechter niet om de ontbinding van het contract vragen tijdens de duur van de opschorting. Zodra hij het
        bewijs heeft ontvangen dat het gezin beschermd is, levert de netbeheerder aan het gezin als noodleverancier. Indien de
        noodleverancier het gezin voorziet van elektriciteit en gas, is artikel 20novies, vijfde lid van toepassing. Het afbetalingsplan kan
        heronderhandeld worden en wordt door de leverancier aan de noodleverancier meegedeeld.
      </p>

      <p>
        § 5. Elke &quot; beschermde afnemer &quot; is een &quot; kwetsbare consument &quot; in de zin van de Richtlijn 2009/73/EG van het
        Europees Parlement en de Raad van 13 juli 2009 betreffende gemeenschappelijke regels voor de interne markt voor gas.
      </p>

      <p>
        § 6. Zodra het gezin alle schuld heeft aangezuiverd in naleving van het afbetalingsplan deelt de leverancier dit mee aan de
        noodleverancier. Het gezin wordt niet meer erkend als beschermde afnemer en de opschorting van het contract zoals bedoeld in § 4
        wordt beëindigd.
      </p>

      <p>
        Behalve indien het statuut afloopt overeenkomstig paragraaf 3bis of beëindigd wordt overeenkomstig het eerste lid of op schriftelijk
        verzoek van het gezin, blijft het gezin het statuut van beschermde afnemer behouden zolang het voldoet aan de voorwaarden vastgelegd
        in paragraaf 1, 2 of 3 en het zijn afbetalingsplan naleeft.
      </p>

      <p> De noodleverancier vraagt om de twee jaar :</p>

      <p>
        1° dat het gezin binnen de negentig dagen na zijn schriftelijk verzoek het bewijs levert dat hij voldoet aan de voorwaarden
        vastgelegd in paragraaf 1, 2 of 3. De noodleverancier brengt het O.C.M.W. hiervan op de hoogte. Na deze termijn wordt de schorsing
        beëindigd en wordt het contract tussen de leverancier en het gezin volledig hervat. De noodleverancier brengt het O.C.M.W. hiervan
        op de hoogte ;
      </p>

      <p>
        2° aan de leverancier te bevestigen dat het gezin zich aan zijn afbetalingsplan houdt. Als het gezin zijn afbetalingsplan niet
        naleeft, wordt de schorsing beëindigd en wordt het contract tussen de leverancier en het gezin volledig hervat. De noodleverancier
        brengt het O.C.M.W. hiervan op de hoogte.
      </p>

      <p> § 7. ...</p>

      <p></p>

      <p>
        Art. 20sexies. § 1. Als het afbetalingsplan niet wordt nageleefd en indien de afnemer niet als beschermde afnemer werd erkend, kan
        de leverancier aan de vrederechter de ontbinding van het contract verbonden met het gezin en de toestemming tot afsluiting door de
        netbeheerder vragen na het bewijs te hebben geleverd van de naleving van de procedure voorzien in de artikelen 20bis tot 20quinquies
        en na handhaving van de levering gedurende een periode van minimum zestig dagen op onafgebroken wijze vanaf de datum waarop de
        ingebrekestelling aan het gezin werd overgemaakt.
      </p>

      <p>
        § 2. Het verzoek tot ontbinding van het contract en tot toestemming voor het afsluiten kan worden ingeleid op tegensprekelijk
        verzoekschrift, overeenkomstig artikel 1034bis van het Gerechtelijk Wetboek.
      </p>

      <p>
        De akte van rechtsingang bevat de vermelding die bepaalt dat het gezin, teneinde het bedrag dat voor zijn verbruik wordt opgeëist te
        verifiëren, een afrekening van de verschuldigde sommen en een opname van zijn meter kan laten uitvoeren op kosten van de
        leverancier, bij gebrek aan een opgenomen meterstand of wanneer de meterstand niet werd meegedeeld door de afnemer en gevalideerd
        door de distributienetbeheerder, in de laatste drie maanden.
      </p>

      <p>De distributienetbeheerder voert de opname uit binnen de vijftien dagen vanaf het in vorig lid bedoelde verzoek van het gezin.</p>

      <p>
        § 3. De vraag aan de vrederechter wordt door de leverancier aan het O.C.M.W. van de gemeente van de woonplaats van de afnemer
        meegedeeld, evenals het bewijs van de naleving van de procedure, tenzij het gezin vroeger de mededeling van zijn naam heeft
        geweigerd overeenkomstig artikel 20quater, § 1, teneinde het voor het O.C.M.W. mogelijk te maken om in te grijpen.
      </p>

      <p>
        § 4. Ieder vonnis dat de ontbinding van het contract uitspreekt geeft van rechtswege de toelating tot afsluiting door de betrokken
        distributienetbeheerder, met inbegrip van de toegang tot de meter met bijstand van de openbare macht indien noodzakelijk.
      </p>

      <p>
        § 5. Voor het geval dat het gezin op het adres van het verbruik is gedomicilieerd, kan de leverancier slechts één maand na ,
        enerzijds, de betekening aan het gezin van het vonnis van ontbinding en, anderzijds, de schriftelijke of elektronische mededeling
        aan het O.C.M.W. van de gemeente waar zijn afnemer woont van zijn beslissing over te gaan tot deze afsluiting in uitvoering van dit
        vonnis, behalve indien het gezin daarvoor de mededeling in zijn naam geweigerd heeft in toepassing van artikel 20quater, § 1 tot de
        afsluiting laten overgaan.
      </p>

      <p>
        § 6. Zonder afbreuk te doen aan artikel 20quater, § 2 kan de afsluiting van een gezin niet plaatsvinden in de winterperiode, de
        periode tijdens dewelke de levering aan het gezin door de noodleverancier wordt gewaarborgd. Indien de noodleverancier het gezin
        voorziet van elektriciteit en gas, is artikel 20novies, vijfde lid, van toepassing. Dat verbod op het afsluiten van een gezin heeft
        betrekking op de afsluitingsaanvragen na machtiging door de vrederechter en de aanvragen voor de afsluiting van een afnamepunt
        waarvoor het contract afloopt tijdens de winterperiode. Dit verbod tot afsluiting heeft geen betrekking op afsluitingen om
        veiligheidsredenen. Wanneer de reden voor de aanvraag tot afsluiting van een afnamepunt het aflopen van het contract tijdens de
        winterperiode is, wordt de afsluitingsaanvraag uitgevoerd aan het einde van de winterperiode, tenzij het gezin over een nieuw
        leveringscontract voor het desbetreffende afnamepunt beschikt.
      </p>

      <p> ...</p>

      <p>
        De Regering kan na advies van Brugel de aanvullende regels en voorwaarden vaststellen met betrekking tot de leveringen in de winter
        van deze paragraaf. Zij kan uitzonderlijk de winterperiode verlengen tot na 31 maart indien het klimaat dat vereist of in geval van
        overmacht.
      </p>

      <p>§ 7. De leverancier en de noodleverancier delen onderling en elk semester de staat van de naleving van het afbetalingsplan mee.</p>

      <p>
        § 8. Indien de beschermde afnemer echter schulden ten opzichte van de noodleverancier heeft gevestigd, kan deze zijn vorderingen met
        alle wettelijke middelen terugvorderen.
      </p>

      <p> ...</p>

      <p>
        Als de beschermde afnemer in gebreke blijft van betaling van de noodleverancier, nadat deze hem in gebreke gesteld heeft, deelt deze
        leverancier aan het O.C.M.W. van de gemeente van het leveringspunt de naam en het adres van de beschermde afnemer mee. Als uiterlijk
        zestig dagen na de mededeling van de naam van de beschermde afnemer aan het O.C.M.W., deze laatstgenoemde niet aan de
        noodleverancier heeft laten weten dat deze afnemer bijstand van het O.C.M.W. geniet of niet aan de noodleverancier een voorstel van
        afbetalingsplan voor alle schulden ten aanzien van de noodleverancier, medeondertekend voor akkoord door de afnemer, heeft
        overgemaakt, kan de noodleverancier aan de vrederechter de ontbinding van het noodleveringscontract vragen, met bewijs van naleving
        van de voorziene procedure. Evenzo, kan de noodleverancier de ontbinding van het noodleveringscontract vragen in geval van
        niet-naleving van het hierboven aangehaalde afbetalingsplan. De ontbinding van het noodleveringscontract heeft van rechtswege de
        ontbinding van het contract met de oorspronkelijke leverancier tot gevolg. De Regering kan de modaliteiten voor deze procedures
        vastleggen.
      </p>

      <p>
        § 9. Indien een gezin niet beleverd zou worden of schulden heeft bij minstens twee leveranciers, kan het O.C.M.W. na een
        maatschappelijk onderzoek de noodleverancier een gewaarborgde levering ten laste van het gezin opleggen gedurende twaalf maanden.
      </p>

      <p>
        De noodleverancier kan de gewaarborgde levering weigeren als het gezin een schuld van minstens 300 euro heeft bij de noodleverancier
        en er voor deze schuld geen redelijk afbetalingsplan is overeengekomen.
      </p>

      <p>
        De gewaarborgde levering loopt af na een periode van twaalf maanden, te rekenen vanaf de eerste dag van de gewaarborgde levering
        door de noodleverancier, tenzij deze vooraf op verzoek van het gezin is beëindigd of het gezin een leveringscontract heeft gesloten
        voor het betreffende afnamepunt.
      </p>

      <p>
        Het O.C.M.W. kan de gewaarborgde levering na een maatschappelijk onderzoek verlengen voor een nieuwe periode van twaalf maanden.
      </p>

      <p>
        Na afloop van deze periode van twaalf maanden en bij gebrek aan een leveringscontract voor het betreffende afnamepunt of van een
        verlenging van het recht op gewaarborgde levering, sluit de netbeheerder het betreffende afnamepunt af. De afsluiting van een gezin
        op grond van deze paragraaf kan, overeenkomstig paragraaf 6, niet plaatsvinden tijdens de winterperiode.
      </p>

      <p>
        De noodleverancier stuurt het gezin dat een gewaarborgde levering geniet uiterlijk vier maanden voor het verstrijken van de periode
        van twaalf maanden een brief om :
      </p>

      <p> 1° het te herinneren aan de vervaldatum van zijn recht op gewaarborgde levering ;</p>

      <p>
        2° het uit te nodigen om een leveringscontract te sluiten dat uiterlijk bij het verstrijken van zijn recht op gewaarborgde levering
        in werking treedt ;
      </p>

      <p>
        3° het te herinneren aan de mogelijkheid om zijn recht op gewaarborgde levering te verlengen en het te verzoeken om contact op te
        nemen met het O.C.M.W. van zijn woonplaats indien het een dergelijke verlenging wenst aan te vragen ;
      </p>

      <p>
        4° het eraan te herinneren dat bij het verstrijken van zijn recht op gewaarborgde levering het afnamepunt in kwestie zal worden
        afgesloten als er geen leveringscontract is afgesloten of het recht op gewaarborgde levering niet werd verlengd.
      </p>

      <p> Deze kennisgeving gebeurt per aangetekende brief.</p>

      <p>
        Indien het gezin dat een gewaarborgde levering geniet echter schulden ten opzichte van de noodleverancier heeft gevestigd, kan deze
        zijn schuldvorderingen met alle rechtsmiddelen middelen terugvorderen.
      </p>

      <p>
        Een kwalitatieve en kwantitatieve evaluatie van de uitvoering van deze paragraaf wordt uiterlijk in januari 2025 door de Regering,
        op voorstel van de minister, aan het Brussels Hoofdstedelijk Parlement meegedeeld. Deze evaluatie omvat minstens de volgende
        elementen : het aantal gezinnen dat een gewaarborgde levering geniet en de kosten die de uitvoering van deze paragraaf meebrengt.
      </p>

      <p> Art. 20septies</p>

      <p>
        Om aan de afnemers begrijpelijke en onderling vergelijkbare voorstellen te doen, vermeldt de leverancier, ongeacht zijn prijzen en
        tarieven, in zijn voorstel, duidelijk en afzonderlijk, de eenheidsprijs en de gemiddelde prijs van elke gefactureerde kWh volgens de
        verkochte hoeveelheden en per tariefcategorie, de periodieke forfaits, de retributies, de belastingen, de abonnementen en de prijzen
        van eventuele andere diensten. Op voorstel van Brugel, stelt de Regering de minimumnormen vast waaraan de documenten van voorstellen
        van contract en de facturatiedocumenten moeten voldoen.
      </p>

      <p></p>

      <p> Art. 20octies</p>

      <p>
        In geval van verhuizing binnen het grondgebied van het Brussels Hoofdstedelijk Gewest ..., zorgt de leverancier ervoor, voor zover
        zulks technisch mogelijk is, dat het gezin hetzelfde contract of dezelfde contractuele en tariefvoorwaarden heeft als die welke het
        tot dusver had, en dit tot het verstrijken van het lopende contract. ...
      </p>

      <p>
        In geval van verhuis en bij afwezigheid van afsluiting van de meter wordt een tegensprekelijk opname van de meterstand uitgevoerd
        door de oude en de nieuwe bewoner of door de oude bewoner en de eigenaar van het goed dat beleverd wordt. Hiertoe wordt een
        verhuisformulier opgesteld en door Brugel aangeboden op haar website. Bij ontstentenis van een tegensprekelijke opname die wordt
        overgemaakt aan de netbeheerder , per aangetekende brief of via elektronische weg, of van opname die aan deze door een leverancier
        werd gevraagd, heeft houdt de netbeheerder rekening met de stand die bezorgd wordt door de oude of de nieuwe bewoner aan de hand van
        een foto van de meter genomen op de dag van zijn vertrek of op de dag dat hij op de plaats aankomt, de schatting van de effectieve
        stand die werd uitgevoerd door de netbeheerder bewijskracht tot het tegendeel bewezen is.
      </p>

      <p>
        Art. 20novies. Zonder dat zij op geen enkele wijze mogen discrimineren en met name discriminatie inzake kost, investering en tijd,
        zien de leveranciers en de tussenpersonen erop toe dat :
      </p>

      <p>
        1° wanneer hun afnemers van leverancier wensen te veranderen, met inachtneming van de bepalingen en voorwaarden van de contracten,
        geschiedt deze wissel binnen een termijn van maximaal drie weken te rekenen vanaf de datum van de vraag van de eindafnemer. De
        netbeheerder zorgt voor de aangepaste structuren voor de verwezenlijking van deze verplichting;
      </p>

      <p>
        2° aan hun eindafnemers alle relevante gegevens te verstrekt worden betreffende hun verbruik, evenals het geheel van de persoonlijke
        gegevens in hun dossiers.
      </p>

      <p>
        Bovendien, zien de leveranciers en de tussenpersonen erop toe dat een hoog beschermingsniveau aan hun afnemers wordt verzekerd, met
        name wat de transparantie van de contractuele voorwaarden, de algemene informatie en de mechanismen voor de beslechting van
        geschillen betreft.
      </p>

      <p>
        (Het systeem inzake bescherming van de artikelen 20quater tot 20sexies wordt in herinnering gebracht op elke factuur, aanmaning tot
        betaling of ingebrekestelling van een factuur volgens een model bepaald door de Regering evenals de contactgegevens van het
        Informatiecentrum voor gas- en elektriciteitsconsumenten van artikel 33bis van de ordonnantie van 19 juli 2001.
      </p>

      <p>
        Deze documenten omvatten ook een exacte en gedetailleerde afrekening van alle van de verbruiker geëiste bedragen, volgens een door
        Brugel vastgelegd model, inclusief de forfaitaire bedragen geëist bij wijze van kosten voor de herinnering en de ingebrekestelling,
        in uitvoering van artikel 20quater, § 1..
      </p>

      <p>
        De facturatie van gas mag niet verward worden met de facturatie van elektriciteit. Nochtans mag de elektriciteits- en gasleverancier
        één enkele factuur verzenden voor de twee soorten energie, waarbij in detail het verbruik wordt vermeld in monetaire eenheden en in
        energetische eenheden van de twee soorten geleverde energie. De Regering kan de modaliteiten betreffende deze bepalingen
        vaststellen.){' '}
      </p>

      <p></p>

      <p>
        Art 20decies De sociale bescherming die wordt voorzien door de federale wetgeving inzake tarieven voor beschermde afnemers, wordt
        uitgebreid tot de afnemers die worden bevoorraad door de netbeheerder krachtens deze ordonnantie.
      </p>

      <p>
        Art 20undecies § 1. Onder voorbehoud van een federale norm die gunstiger is voor de afnemer, ... hebben de nadere regels inzake de
        voorlichting van de eindgebruikers door de leveranciers tot doel dat de afnemers :
      </p>

      <p> 1° recht hebben op een contract met hun gasleverancier waarin zijn opgenomen :</p>

      <p> a) de identiteit en het adres van de leverancier;</p>

      <p>b) de geleverde diensten, de aangeboden kwaliteitsniveaus van de diensten en de benodigde tijd voor de eerste aansluiting;</p>

      <p> c) de aangeboden soorten onderhoudsdiensten;</p>

      <p>
        d) de wijze waarop de meest recente informatie over alle geldende tarieven gebundelde producten of diensten en onderhoudskosten kan
        worden verkregen;
      </p>

      <p>
        e) de duur van het contract, de voorwaarden voor verlenging en beëindiging van het contract en onderbreking van de diensten, met
        inbegrip van producten of diensten die met deze diensten gebundeld zijn en of kosteloze opzegging van het contract toegestaan is ;
      </p>

      <p>
        f) alle vergoedingen en terugbetalingsregelingen die gelden indien de contractuele kwaliteitsniveaus van de diensten niet worden
        gehaald, met inbegrip van onnauwkeurige of te late facturering;
      </p>

      <p>g) de methode voor het beginnen van buitengerechtelijke procedures voor de beslechting van geschillen;</p>

      <p>
        h) informatie over consumentenrechten, met inbegrip van klachtenbehandeling en de in dit punt bedoelde informatie, welke duidelijk
        wordt meegedeeld door middel van de facturen of via de websites van het gasbedrijf.
      </p>

      <p>
        De contractuele voorwaarden zijn billijk en vooraf bekend. In ieder geval wordt deze informatie voorafgaand aan de ondertekening of
        bevestiging van het contract verstrekt. Indien contracten door middel van tussenpersonen worden gesloten, wordt bovengenoemde
        informatie eveneens voorafgaand aan de ondertekening van het contract verstrekt.
      </p>

      <p>De eindafnemers krijgen een goed zichtbare, beknopte en duidelijke samenvatting van de voornaamste contractuele voorwaarden;</p>

      <p>
        2° tijdig in kennis worden gesteld van ieder voornemen de contractuele voorwaarden te wijzigen en op de hoogte worden gesteld van
        hun recht het contract op te zeggen wanneer zij van een dergelijk voornemen in kennis worden gesteld. De leveranciers brengen hun
        eindafnemers op een transparante en begrijpelijke manier op de hoogte van aanpassingen van de leveringsprijs en van de redenen, de
        voorafgaande omstandigheden en de reikwijdte van deze aanpassingen, en doen dit tijdig en ten laatste twee weken voor de aanpassing
        van kracht wordt of, voor huishoudelijke afnemers, ten laatste een maand voor de aanpassing van kracht wordt. Het staat de
        eindafnemers vrij om een contract op te zeggen indien zij de hun door de elektriciteitsleverancier meegedeelde nieuwe contractuele
        voorwaarden of aanpassingen van de leveringsprijs niet aanvaarden ;
      </p>

      <p>
        3° transparante informatie ontvangen over geldende prijzen en tarieven, waaronder de sociale tarieven, en over standaardvoorwaarden
        met betrekking tot de toegang tot en het gebruik van gasdiensten ; op verzoek van de afnemers, worden hen tijdig informatie en
        schattingen met betrekking tot de energiekosten verstrekt in een bevattelijke vorm die hen toelaat aanbiedingen op basis van gelijke
        criteria te vergelijken ;
      </p>

      <p>
        4° een ruime keuze van betalingswijzen wordt aangeboden, die geen enkele categorie eindafnemers discrimineert. Systemen voor
        vooruitbetaling zijn billijk en vormen een goede afspiegeling van het vermoedelijke maandelijkse verbruik. Ieder verschil in de
        tarifering van betalingswijzen of systemen voor vooruitbetaling is objectief, niet-discriminerend en evenredig en mag niet meer
        bedragen dan de rechtstreekse kosten die de begunstigde maakt voor het gebruik van een specifieke betalingswijze of een specifiek
        systeem voor voorafbetaling. Huishoudelijke afnemers die gebruik maken van systemen voor vooruitbetaling, worden niet benadeeld door
        deze systemen voor vooruitbetaling ;
      </p>

      <p> 5° geen kosten in rekening worden gebracht indien zij van leverancier veranderen;</p>

      <p> ...</p>

      <p>
        6° naar behoren worden geïnformeerd , met name via elektronische weg, over hun werkelijk gasverbruik en de kosten daarvan, zulks
        voldoende frequent, minstens eenmaal in een periode van 12 maanden, om hen in staat te stellen hun eigen gasverbruik te regelen.
        Voor de verstrekking van de informatie wordt een voldoende ruime termijn ingesteld, waarbij rekening wordt gehouden met de
        capaciteit van de meetapparatuur van de afnemer, met het gasproduct in kwestie en met de kostenefficiëntie van deze maatregelen.
        Voor deze dienst mogen de verbruiker geen extra kosten worden aangerekend, het omvat niet het recht om een gratis aanpassing van de
        meterinrichting of van de periodiciteit van de meteropname te eisen. De leverancier brengt de eindafnemer proactief op de hoogte van
        zijn recht hem een keer per jaar zonder kosten een meteropname met het oog op het verkrijgen van precieze informatie over de
        facturatie en de actuele energiekost ; slechts een opname die gevalideerd werd door de distributienetbeheerder is geldig voor iedere
        facturatie, zelfs als de eindafnemer uitgerust is met ... een slimme meter. ;
      </p>

      <p>
        7° na iedere verandering van gasleverancier ten laatste maximaal zes weken nadat deze leverancier hiervan in kennis is gesteld een
        definitieve afsluitingsrekening ontvangen. De nadere regels met betrekking tot de informatie van de eindafnemers door de
        distributienetbeheerders, de gewestelijke transmissienetbeheerders en de leveranciers, en in het bijzonder betreffende de incidenten
        en stopzettingen van levering, evenals de nadere regels betreffende het klachtenbeheer, worden vastgelegd door Brugel;
      </p>

      <p>
        8° eerlijke en transparante algemene voorwaarden krijgen, die opgesteld zijn in duidelijke en begrijpelijke taal en die geen
        niet-contractuele belemmeringen bevatten voor het uitoefenen van de rechten van eindafnemers, zoals overdreven contractuele
        documentatie. Eindafnemers worden beschermd tegen oneerlijke of misleidende verkoopmethoden.
      </p>

      <p>
        § 2. Onverminderd het bepaalde in § 1, behalve indien kan worden aangetoond dat het om een noodsituatie of een situatie met
        verschillende incidenten gaat, licht de ... netbeheerder de gebruikers van het net minimum tien werkdagen van tevoren in over het
        begin en de vermoedelijke duur van de onderbreking. Deze termijn wordt ingekort tot vijf werkdagen, indien het gaat om de
        regularisering van een voorlopige herstelling. In voorkomend geval, licht de evenwichtsverantwoordelijke de leverancier in.
      </p>

      <p>
        § 3. Naast de in § 2 bepaalde informatie, publiceert de ... netbeheerder binnen 24 uur op zijn website de lijst, de duur en de
        oorzaken van de geplande of incidenfactur tele onderbrekingen die hebben plaatsgevonden op het net onder gemiddelde spanning. Deze
        informatie wordt eveneens meegedeeld aan Brugel.
      </p>

      <p>
        § 4. De leveranciers en de netbeheerders stellen een klachtenbehandelingdienst ter beschikking van hun respectieve afnemers waarbij
        de afnemers kunnen rekenen op transparante, eenvoudige en goedkope procedures. Deze dienst bevestigt de ontvangst van iedere klacht
        binnen een termijn van vijf werkdagen en verstrekt een met redenen omkleed antwoord binnen de twintig werkdagen vanaf de
        ontvangstbevestiging. Deze procedure van buitengerechtelijke geschillenbeslechting laat een billijke en snelle regeling van de
        geschillen toe binnen een termijn van twee maanden, die wordt aangevuld met, waar dat gerechtvaardigd is, een systeem van
        terugbetaling en/of vergoeding. Brugel bepaalt de straffen die in geval van niet-naleving van deze verplichting worden opgelopen en
        kan de modaliteiten bepalen die met betrekking tot de doeltreffendheid van de dienst worden verwacht.
      </p>

      <p> § 5. ...</p>

      <p> Art. 20duodecies.</p>

      <p>
        Ten aanzien van de professionele afnemers die minder dan 5 personen in dienst hebben en die aangesloten zijn op het distributienet,
        is de leverancier ertoe verplicht eerst een herinneringsbrief en daarna een aanmaningsbrief te sturen en vervolgens over een
        aanzuiveringsplan te onderhandelen, voordat hij zijn leveringscontract kan verbreken.
      </p>

      <p></p>

      <p> Art. 20tredecies</p>

      <p>
        § 1. De Regering kan de leveranciers, bij wijze van openbaredienstverplichting, verplichten om de doelstellingen en de communicatie
        van de prestatie-indicatoren inzake hun prestaties na te leven in functie van het aantal beleverde afnemers, op basis van een door
        Brugel geformuleerd voorstel na overleg met de leveranciers. Brugel controleert of deze doelstellingen nagekomen werden en
        publiceert elk jaar op zijn website de respectievelijke prestaties van elke leverancier ten opzichte van deze doelstellingen.
      </p>

      <p>
        § 2. De Regering kan andere modaliteiten van verplichtingen van openbare dienst bepalen wat betreft de regelmatigheid, de kwaliteit
        en de facturatie van de leveringen.
      </p>

      <p></p>

      <p>
        Art. 20quattuordecies. Om de openbare dienstverplichtingen, die in dit hoofdstuk voor hen worden bepaald, te vervullen krijgen de
        O.C.M.W.&apos;s middelen van het fonds waarvan sprake is in artikel 2, 15° van de ordonnantie van 12 december 1991 houdende
        oprichting van begrotingsfondsen.
      </p>

      <p> </p>

      <p>
        Art. 20quindecies. De opdrachten waarmee de O.C.M.W.&apos;s door en krachtens deze ordonnantie worden belast, worden begrepen en
        uitgeoefend, onverminderd het bepaalde in artikel 109 van de organieke wet van 8 juli 1976 betreffende de openbare centra voor
        maatschappelijk welzijn en met uitsluiting van elke vorm van administratief toezicht op de beslissingen om individuele hulp toe te
        kennen en terug te vorderen.
      </p>

      <p></p>

      <p>
        Art. 20sexiesdecies. In geval van faillissement of van intrekking van de leveringsvergunning van een leverancier, zal de levering
        van de eindafnemers door de standaardleverancier worden verzekerd aan de voorwaarden van de standaardlevering voor een maximale duur
        van een jaar.
      </p>
    </>
  )
}

export default TermsDutch
